export default {
  all: "Todos",
  close: "Chiudi",
  actions: {
    confirm: "Confirmar",
    cancel: "Cancelar",
    correct: "Corregir",
    showAll: "Ver todas",
    edit: "Editar",
    delete: "Eliminar",
    share: "Compartir",
    download: "Descargar",
    display: "Visualizar",
    close: "Cerrar",
    duplicate: "Duplicar",
    goDocuments: "Ir al documento",
    goDeadline: "Ir al vencimiento",
    apply: "Guardar",
    add: "Añadir",
    pay: "Pagar",
    save: "Guardar",
    discoverMore: "Descubrir más",
    activate: "Activar",
    goBack: "Volver",
    insert: "Introduce",
    addComment: "Introduce el comentario",
    search: "Buscar",
    login: "Inicia sesión",
  },
  saved: "Salvato",
  minute: "minuto",
  minutes: "minuti",
  ago: "fa",
  generalText: {
    orText: "o",
    ts: "TeamSystem",
  },
  usedGoods: {
    title: "Gestione beni usati",
  },
  upload: {
    newDocument: "Subir nuevos documentos",
    orNewDocument: "O cargar nuevo documento",
    acceptedFiles: "Archivo aceptado",
    maxSize: "Tamaño máx 16mb",
    title: "CARGAR NUEVOS DOCUMENTOS",
    selectedDocuments: "Documentos seleccionados",
    mainData: "DATOS PRINCIPALES",
    comments: "Comentarios",
    confirm: "Confirmar la carga",
    feedback: {
      success:
        "{total} ¡Los documentos se han cargado con éxito! En unos minutos los encontrarás en la sección de documentos. Continúa con otras subidas o ve a la sección de Documentos",
      noPermissions:
        "La carga no ha funcionado. No tienes permisos para cargar documentos en formato xml. Contacta con el servicio de asistencia para más información.",
      genericError: "Se ha producido un error en la carga. Revisa los archivos y repite el proceso. ",
      successUploaded: "Archivos cargados con éxito y",
      inError: "Error",
      goToDocuments: "Puedes ir a la selección de documentos para su control o continuar con la carga de otros archivos.",
    },
    optionalData: {
      crypt: {
        title: "Cifrar documento",
        desc1: 'Si tu documento contiene datos sensibles y quieres protegerlos, selecciona la opción "cifrar el documento".',
        desc2: "Qué significa?",
        desc3: "No podrás previsualizar el documento, tendrás que descargar el archivo para verlo",
        desc4: "Recuerda que los documentos encriptados no serán indexados en la búsqueda.",
      },
      onlyStudio: {
        title: "Visible sólo en tu asesoría",
        desc1: "Al seleccionar esta opción, el documento asociado a este cliente sólo será visible para tu asesoría.",
        desc2: "Para que sea visible para el cliente en una fecha posterior, selecciona la opción en la lista de documentos.",
      },
      toAccount: {
        title: "Para contabilizar",
      },
    },
    widget: {
      title: "Arrastrar uno o varios documentos",
      button: "Subir archivo",
    },
  },
  prelogin: {
    advertisingTitle: "<highlight>Colabora</highlight> con tu Asesoría de forma fácil y ecológica gracias a Digital Box.",
    title: "Accede o regístrate a TeamSystem Digital",
    subtitle: "Comparte documentos rápidamente y de forma segura, gestión de vencimientos y una visión completa y detallada sobre la actividad de la empresa",
    copyright: "© 2023 TeamSystem S.p.A.",
    privacyPolicy: "Política de Privacidad",
    cookie: "Cookie",
    thousands: "mil",
    managedCompanies: "Empresas",
  },
  customersWidget: {
    title: "Clientes",
    showAllCustomers: "Mostrar todos los clientes",
    allCustomers: "Todos los clientes",
    activeOnDigitalbox: "Activo en Digital Box",
    activeDigitalbox: "Activar Digital Box",
    awaitingDbx: "En espera de aceptación...",
    piva: "NIF-IVA: ",
    cf: "NIF: ",
    company: "Empresa",
    user: "Privado",
    openPage: "Abrir información cliente",
    noPermissions: "No tienes permisos para acceder a los datos de esta empresa",
    activeDbxTooltip: "Al hacer clic aquí, podría ser necesario efectuar el proceso de Inicio de sesión.",
    tsPayBanner: "Puedes importar automáticamente tu extracto bancario en el programa y hacer la conciliación con los movimientos contables",
    checkupImpresaBanner:
      "La solución para controlar en todo momento el balance económico y financiero de la empresa, ver las tendencias del negocio o compartir indicadores de crisis.",
  },
  widgetTools: {
    active: "Activar otras opciones",
    tools: "Opciones",
  },
  analytics: {
    noChartOnCompany: "Ningún gráfico disponible para la empresa seleccionada.",
    cantSeeGraph: "Si no ves este gráfico, comprueba si la empresa puede enviar datos a TS Analytics",
    activateToSeeGraph: "Para ver este gráfico conecte la empresa con Rendimiento empresarial",
    cashFlowModalTitle: "Saldo",
    cashFlowContent: "Añadir importes para calcular el flujo de caja.",
    cashFlowPlaceHolder: "Para visualizar el flujo de caja debes actualizar el saldo.",
    cashFlowUpgradeBalance: "Actualizar saldo",
    currentAccountBalance: "Saldo cuenta corriente *",
    cashAndCashEquivalents: "Líquido disponible",
    or: "o",
    activeTsPay: "Activar TS Pay",
    findOutTsPay: "Descubre TS Pay",
    viewCashFlow: "Ver Flujo de Caja",
    balance: "Saldo",
    lastUpdate: "Actualizado el",
    attention: "Atención: ",
    visualizeBefore: "Puedes ver el flujo de caja para los próximos 3 meses desde la fecha de hoy.",
    visualizeAfter: "Las previsiones del flujo de caja están disponibles para los próximos 3 meses desde la fecha de hoy.",
    goBack: "Volver",
    selectMonth: "Selecciona el mes actual.",
    businessPerformance: {
      modalTitle: "Información",
      modalDate: "Fecha de última sincronización",
    },
  },
  creditsAndRevenues: {
    credits: "Créditos de la asesoría",
    revenues: "Ingresos de la asesoría",
    proforma: "Proforma",
    invoice: "Factura",
    invoices: "Facturas",
    year: "año",
    placeholdercredits: "Para ver los créditos de la asesoría, activa el módulo de Gestión de Asesorías de Teamsystem.",
    placeholderrevenues: "Para ver los ingresos de la asesoría, activa el módulo de Gestión de Asesorías de Teamsystem.",
  },
  obligations: {
    title: "Obligaciones",
    tabGeneral: {
      title: "General",
    },
    tabAccounting: {
      title: "Contabilidad",
    },
    tabRevenues: {
      title: "Ingresos",
    },
    tabWages: {
      title: "Nóminas",
    },
    tabPayments: {
      title: "Pagos",
    },
    tabSubstitute: {
      title: "Sustitutos",
    },
    tabOther: {
      title: "Otros",
    },
  },
  checkup: {
    default1year: "Probabilidad de incumplimiento",
    netAssets: "Patrimonio neto",
    approach: "Acercar",
    financialSustainability: "Sostenibilidad de los cargos financieros",
    capitalAdequacy: "Adecuación de capital",
    liquidity: "Liquidez",
    liquidityReturn: "Retorno líquido del activo",
    socialDebt: "Seguridad social y deuda tributaria",
    sectorIndices: "Índice de sector",
    crisisCompanies: "Empresas que presentan índices de crisis",
    ratingCompanies: "Distribución de empresas por clasificacion",
    crisisIndex: "Índices de la crisis",
    sectorsIndex: "Índices de sector",
    financialIndex: "Indicadores económico-financieros",
    noAnalysisCrisis: "En esta sección, tras de la aprobación del análisis, se mostrarán las empresas que presentan signos de crisis.",
    noAnalysisRating: "En este apartado, tras la aprobación de los análisis Checkup de empresa, se mostrarán las empresas distribuidas por Rating.",
    noRating: "En este apartado, tras la aprobación de los análisis Checkup de empresa, se mostrarán los datos de Rating de las empresas.",
    noDSCR: "En este apartado, tras la aprobación de los análisis Checkup de empresa, se mostrarán los datos RCSD.",
    noSectorsIndex: "En este apartado, tras la aprobación de los análisis Checkup de empresa, se mostrarán los índices del sector.",
    checkupBanner: "Activa Checkup de empresa para controlar en todo momento el equilibrio económico-financiero de las empresas.",
    accountantBanner:
      "la solución para controlar en todo momento el equilibrio económico-financiero de las empresas, ver tendencias comerciales y compartir indicadores de crisis.",
    monitoringCompanies: "Mantén controladas las empresas",
  },
  ask: {
    title: "Solicitudes",
    header1: "Pide a tus clientes",
    header2: "la información y los archivos que necesitas",
    noAsk: "No se encontraron solicitudes",
    noAsk2: "No hay solicitudes",
    createFirst: "Crea tu primera solicitud",
    changeFilters: "Intenta cambiar los filtros o",
    changeFiltersCreate: "crea una nueva solicitud",
    searchPlaceholder: "Buscar por título de la solicitud",
    saveDraft: "Guardar borrador",
    feedback: {
      ok1: "Tu solicitud",
      ok2: "ha sido enviada",
      okTemplate1: "Tu plantilla",
      okTemplate2: "ha sido guardada",
      ok2draft: "se ha guardado como borrador",
      button: "Volver a todas las solicitudes",
      docTitle: "Documento adjunto",
      docsTitle: "Documentos adjuntos",
      docDescription1: "El archivo",
      docDescription2: "ha sido adjuntado a los documentos.",
      docsDescription: "Los archivos se han adjuntado a los documentos.",
      docHint: "Podría tardar unos segundos antes de poder visualizarlo en la sección correspondiente.",
    },
    header: {
      title1: "Crea solicitudes automáticas para recibir documentos de tus clientes",
      subtitle1: "Utiliza plantillas estándar o guarda las tuyas personalizadas.",
      companyTitle1: "¿Qué documentos se necesitan para tu trabajo?",
      companySubtitle1:
        "Responde a las solicitudes enviadas por tu asesor o envía las tuyas directamente, eligiendo solicitudes estándar para documentación sobre hipotecas, préstamos, compras de automóviles y mucho más.",
    },
    widget: {
      showAll: "Mostrar todas las solicitudes",
      emptyWidget: "Actualmente no has creado o recibido ninguna solicitud.",
      toFill: "Esperando respuesta",
      toRead: "No leído",
      title: "Nueva solicitud",
    },
    tooltips: {
      addNewAsk: "Crea una nueva solicitud",
      addNewAskCompany: "Envía una nueva solicitud",
    },
    pages: {
      answer: {
        uploadHint: "Solo XML, P7M, PDF, JPEG, JPG, PNG, DOC, DOCX, XLS, XLSX, CSV tamaño máximo 16MB",
        createdAt: "Creado el",
        completedAt: "Completado el",
        noReply: "Sin respuesta",
        title: "SOLICITUD",
        subtitle: "Completa los campos obligatorios para enviar la documentación a tu asesor",
        start: "¡Empecemos!",
        compileFirst: "Completa la primera pregunta de",
        good: "¡Estás bien encaminado!",
        missingQuestions: "Faltan más",
        questions: "preguntas",
        good2: "Bien hecho",
        youAre: "Estás en la",
        last: "última",
        question: "pregunta",
      },
      list: {
        goBack: "Volver al Inicio",
        subtitle: "Línea directa con tu asesor",
        markAsRead: "Señalar como leído",
        markAsUnread: "Señalar como no leído",
        all: "Todo",
        toRead: "No leídos",
        toSend: "Para enviar",
        draft: "Borrador",
        toFill: "Por completar",
        notFilled: "No completada",
        filled: "Completada",
        solicit: "Enviar recordatorio",
        solicited: "Recordatorio",
        solicitAgain: "Reenviar recordatorio",
        readResponse: "Leer la respuesta",
        open: "Abrir",
        allCustomers: "Todos los clientes",
        confirmDeleteTitle: "Confirmar eliminación",
        confirmDeleteSubtitle: "¿Confirmas la eliminación de la plantilla seleccionada?",
        confirmDeleteSurveySubtitle: "¿Confirmas la eliminación de la solicitud seleccionada?",
        chooseTemplate: "Elige una plantilla",
        requestByStudio: "Solicitud de la asesoría",
        requestByClient: "Solicitud del cliente",
        myOwnRequest: "Mi solicitud",
        sendDate: "Fecha de envío",
        requestDate: "Fecha de envío",
        fillDate: "Fecha de compilación",
        solicitDate: "Fecha de solicitud",
        requestCompleted: "Solicitud eliminada correctamente",
        requestError: "Se ha producido un error al eliminar el borrador",
        error: "ERROR",
      },
      edit: {
        title: "MODELOS",
        publishTemplate: "Guardar plantilla",
        recipientsTip: "Para guardar una plantilla no es necesario seleccionar un destinatario",
        back: "Volver a las solicitudes",
        orderBy: "Ordenar por",
        lastPublish: "Últimas publicaciones",
        categoryPlaceholder: "Selecciona una categoría",
        steps: {
          step1: "Inicio",
          step2: "Formulario",
          step3: "Destinatario",
          step4: "Envío",
        },
        chooseTemplate: {
          title: "Tus plantillas",
          subtitle: "Elige una plantilla para enviar una nueva solicitud",
          titleCompany: "¿Qué solicitud quieres enviar?",
          subtitleCompany: "Elige una plantilla",
          empty: "Nuevo",
          moreOn: "Mostrar todos",
          moreOff: "Ocultar",
          yourTemplatesTab: "Tus plantillas",
          downloadedTemplatesTab: "Lista de plantillas descargadas",
          toValidateTemplatesTab: "Plantillas pendientes de confirmar",
        },
        communityTemplates: {
          title: "Plantillas compartidas",
          subtitle: "Elige una plantilla entre las puestas a disposición por el programa y por tus compañeros.",
          filterTitleCategory: "Categorías",
          placeholderCategory: "Todas",
          filterTitleRating: "Rating",
          placeholderRating: "Todos",
          filterTitleAuthors: "Usuarios",
          placeholderAuthors: "Elige un usuario",
          sorterTitleDate: "Fecha creación",
          sorterTitlePrice: "Precio",
          templatePriceFree: "GRATIS",
          templateDownloads: "Descargas",
          templateDetailSubtitle: "Vista previa plantilla",
          templateDetailTitle: "Título de la solicitud",
          templateDetailCategory: "Categoría",
          detailTemplatePageButton: "Guardar plantilla en tu lista",
          detailTemplatePageGoToAuthorTemplates: "Ver todas las plantillas de este usuario",
          dotsToggle: "Publicar en la tienda de la comunidad",
          dotsToggleTooltip: "Pon esta plantilla a disposición de la comunidad. Podrán usarla y enviarla en cualquier momento.",
          emptyList: "Lo siento, no existen plantillas.",
          downloadedTabSubtitle: "Elige la plantilla para enviar una nueva solicitud",
          downloadedTabTitle: "Descargar biblioteca",
          saveDotsSuccessMessage: "¡Hecho! Selecciona la plantilla de tu biblioteca para comenzar a utilizarla. ",
          saveDotsErrorMessage: "Se ha producido un error durante el guardado de la plantilla",
          saveDotsSuccessLink: " Ir a la biblioteca.",
          createAskDotsButton: "Crear solicitud y plantillas",
          createAskDotsButtonPlaceholder: "En esta sección puedes crear una nueva solicitud o gestionar las plantillas",
          createAskDotsButtonTitlePlaceholder: "Plantillas",
          noDownloadedDots: "No existen todavía plantillas descargadas.",
          sectionTitle: "Buscar una plantilla",
          searchPlaceholder: "Buscar una palabra clave",
        },
        form: {
          title: "Título de la solicitud",
          add: "Añadir una pregunta",
          isShared: "Guardar como plantilla",
          isSharedDesc: "Incluye esta plantilla en la lista de tus plantillas y podrás reutilizarla todas las veces que lo necesites.",
          isPublic: "Siempre a disposición de mis clientes",
          isPublicDesc: "Poner plantilla disponible para tus clientes. Podrán rellenarla y enviarla en cualquier momento, incluso sin que lo hayas solicitado.",
        },
      },
    },
    categories: {
      tax: "Fiscal",
      finance: "Finanzas",
      social_security: "Jubilación/Trabajo",
      accounting: "Contabilidad",
      contract: "Contratos",
      corporate: "Societaria",
      tax_relief: "Beneficios",
      other: "Otros",
      all: "Todos",
      Todos: "Todos",
    },
    builder: {
      question: "Pregunta",
      info: "Información adicional",
      type: "Tipo de respuesta",
      required: "Obligatorio",
      tip: "Añadir indicaciones para ayudar a responder",
      multiplePlaceholder: "Introduzca una opción",
      usersPlaceholder: "Buscar usuarios a los que enviar la solicitud",
      deleteTitle: "Confirmación de eliminación",
      deleteMessage: "¿Confirmar la eliminación del elemento seleccionado?",
      recipients: "Destinatarios",
      previewTitle: "Vista previa de tu solicitud",
      cancelTitle: "Deshacer los cambios y volver al principio",
      cancelMessage: "Al cancelar perderás todos los cambios realizados hasta el momento. ¿Seguro que quieres volver?",
      types: {
        text: "Texto sin formato",
        date: "Fecha",
        currency: "Importe",
        number: "Número",
        file: "Archivo",
        yesno: "Si/No",
        multiple: "Múltiple",
        single: "Único",
      },
      feedback: {
        noQuestion: "La solicitud debe contener al menos una pregunta",
        noTitle: "Por favor, introduce el título de la solicitud",
        noCategory: "Por favor, selecciona la categoría de la solicitud",
        emptyQuestion: "Una de las preguntas introducidas está vacía",
      },
    },
  },
  customerPage: {
    title: "FICHA CLIENTE",
    informations: "Información: ",
    noAvailable: "no disponible",
    registryWidget: {
      company: "Empresa",
      person: "Persona física",
      atecoCode: "Código CNAE",
      multiCode: "Código multis",
      tools: "Herramientas",
      cloudInvoices: "Facturas en la nube",
      bankTransactions: "Movimientos bancarios",
      privacy: "Privacidad",
      notAvailable: "Dato no disponible",
      lastBankTransaction: "Último movimiento bancario",
      lastPurchaseInvoice: "Última factura de compra",
      lastSalesInvoice: "Última factura de venta",
      lastSumDue: "Últimos vencimientos",
      operation: "Operatividad",
      obligations: "Obligaciones de inicio de año",
    },
    analyticsChart: {
      analyticsChart: "Título no disponible",
      showAllBusinesssPerformance: "Ver el rendimiento de tu negocio",
    },
    landing: {
      noDataTitleUp: "Sugiere la mejor estrategia para el éxito de tus clientes",
      noDataSubTitleUp:
        "Ayuda a tus clientes a seguir el progreso de su negocio y conviértete en el consultor de referencia, controlando y compartiendo datos en tiempo real gracias a Rendimiento Empresa.",
      titleMiddle: "Accede a los datos de tus clientes para ofrecer fácilmente un servicio más completo",
      subTitleMiddle1: "Potencia el control del rendimiento integrando otros servicios de TeamSystem.",
      subTitleMiddle2:
        "Si tu cliente utiliza un software de TeamSystem para administrar su negocio, podrá compartir contigo la información de su empresa (con consentimiento previo) y podrás consultarla en tiempo real. Evolución de la facturación, flujo de caja, existencias en almacén y mucho más, siempre actualizado gracias a la información de los sistemas de gestión de tus clientes.",
      collaborationTitle: "Colaboración con los clientes",
      collaborationSub:
        "Un nuevo paradigma operativo, basado en la Colaboración Digital entre la asesoría y sus clientes: estás más cerca de tus clientes y compartes datos e información con ellos en tiempo real.",
      graphKpiTitle: " Gráficos y KPIs empresariales",
      graphKpiSub:
        "Conviértete en un socio de la empresa. Tus clientes pueden compartir contigo datos sobre la marcha de su negocio: facturación, KPIs de inventario y muchos otros, siempre actualizados.",
      newServicesTitle: "Nuevos servicios",
      newServicesSub: "Acceda a los datos de tus clientes para apoyarlos mejor en sus actividades y enriquecer tu oferta de servicios de consultoría.",
      noAuthTitle: "Rendimiento Empresa",
      noAuthSub1: "La herramienta para ayudar a tus clientes a monitorizar el progreso de su negocio compartiendo datos en tiempo real.",
      noAuthSub2:
        "Si no ves la opción de Rendimiento Empresa, es probable que no hayas activado el paquete para tu cliente. Si lo has activado, solicita al administrador que active los permisos para ver estos datos.",
      alertMsg1: "¿Por qué no ves estos gráficos?",
      alertMsg2: "No tienes permiso para ver esta sección o no has activado Rendimiento Empresa para esta empresa.",
      connectionsButton: "Activar Rendimiento Empresa",
      activateBusinessPerformance: "Activar gratuitamente Rendimiento Empresa",
      buyPackage: "Comprar paquete",
      titleMiddleTSPay1: "Colaboración y eficiencia.",
      titleMiddleTSPay2: "Lee más para saber porqué activar la integración entre Digital Box y los servicios de TS Pay.",
      subTitleMiddle1TSPay: "La colaboración con tus cientes nunca ha sido así de fácil y segura.",
      subTitleMiddle2TSPay1:
        "Pondrás a disposición de tus clientes una herramienta para gestionar transferencias desde Digital Box, evitando errores: las transferencias emitidas por Digital Box tienen los datos del IBAN y del importe ya cumplimentados. Reduce el esfuerzo requerido para la contabilización de ingresos.",
      subTitleMiddle2TSPay2:
        "Las empresas podrán importar transacciones bancarias a Digital Box para la conciliación bancaria de los vencimientos. Todos los movimientos relacionados con las transacciones realizadas con TS Pay se pueden conciliar automáticamente.",
      subTitleMiddle2TSPay3:
        "Los datos sensibles de la tarjeta y de la cuenta corriente se tratan de conformidad con la legislación vigente en materia de privacidad; los servicios de pago son proporcionados por TeamSystem Payments S.r.l., autorizado por el Banco de Italia para operar como una institución de pago.",
      doPaymentTitle: "Enviar y recibir pagos",
      reconciliationTitle: "Automatizar la conciliación bancaria",
      cashFlowTitle: "Previsión de flujos de caja",
      doPaymentSub:
        "Tus clientes pueden pagar los honorarios del asesor y proveedores de forma rápida y sencilla y solicitar y realizar pagos a través de un simple enlace.",
      reconciliationSub:
        "Gracias a TSPay, tus clientes podrán reducir las actividades necesarias para asociar las transacciones bancarias a los vencimientos: todo es automático, desde el registro de los recibos hasta la conciliación",
      cashFlowSub:
        "Gracias a la conexión con las cuentas de la empresa, TS Pay cruza los datos del saldo bancario con los de ingresos y gastos, proporcionando a tus clientes una previsión de flujos de caja para los próximos 3 meses.",
      contactUs: "Contáctanos",
      noTSPayTitleUp: "PAGOS SEGUROS PARA TUS CLIENTES SIN SALIR DE DIGITAL BOX",
      noTSPaySubTitleUp:
        "TS Pay es el servicio que permite a tus clientes gestionar recibos y pagos digitales, conciliación bancaria automática y mucho más, dentro de Digital Box.",
      bottomText: "Cuáles son los beneficios para tus clientes?",
      tsPayAlertMsg1: "¡Activa gratuitamente la conexión de TS Pay para este cliente!",
      tsPayAccountantAlertMsg1: "Consentimiento para vincular la cuenta caducada",
      tsPayConnectionsButton: "Conectar",
    },
    docsWidget: {
      inbox: "Bandeja",
      noResults: "Ningún resultado",
      noDocuments: "No hay documentos",
      noDocumentsUnread: "No hay nuevos documentos",
      inviteUpload: "¿Quieres cargar uno ahora?",
      daleggere: "No leído",
      documentsView: "Ver todos los documentos",
    },
    otherWidget: {
      volumeAffari: "Facturación mensual, año actual y anterior",
    },
  },
  dashboard: {
    title: "INICIO",
    goBack: "Ir a TS Digital",
    incassaSubito: "Incassa Subito",
    showMore: "Leer más",
    noDisplay: "No mostrar más",
    showVideo: "Mira el vídeo",
    goToIncassaSubito: "Ir a Incassa Subito",
    detail: "Ver el detalle",
    invoice: "Factura electrónica",
    noInvoices1: "No existen nuevas facturas electrónicas",
    noInvoices2: "Cuando se reciban las facturas, podrás visualizar aquí las más recientes.",
    noRecentInvoices: "No existen facturas recientes",
    accountant: {
      subtitle: "Mi cuenta",
      premium: "Servicio Premium",
    },
    clientsSection: {
      title: "Usuarios de la empresa",
      usersCta: "Ver usuarios",
      noUsersMessage: "Esta empresa todavía no tiene usuarios.",
    },
    tsPayOnboardingMsg1: "Con tu cuenta de Asesor puedes activar gratuitamente TS Pay.",
    tsPayOnBoardingMsg1Studio: "Puedes activar el servicio TS Pay.",
    tsPayOnboardingStartedMsg1: "Atención, no has completado el registro a TS Pay.",
    tsPayOnboardingMsg2: "Gestiona el flujo de pagos de manera fácil y rápida.",
    tsPayConfirmedStatusMsg1: "Atención, para empezar a utilizar TS Pay debes confirmar el correo electrónico que has recibido.",
    buttonTextTsPayOnboarding: "Activar TS Pay",
    buttonTextTsPayOnboardingStarted: "Reanudar",
    buttonTextTsPayConfirmedStatus: "Recibe de nuevo el email",
    tsPayTsPayOnboardingBannerUpperText: "es el servicio que te permite gestionar los pagos de manera fácil y rápida",
    tsPayTsPayOnboardingBannerBottomText:
      "Descubre el servicio que te permite solicitar los pagos con un enlace y saldar los vencimientos sin salir de Digital Box.",
    tsPayText: "TS Pay",
    tsPayTsPayOnboardingBannerLandingUpperText: "ENTRA EN TU BANCO CON DIGITAL BOX",
    tsPayTsPayOnboardingBannerLandingBottomText:
      "TS Pay es el servicio que te permite gestionar pagos de manera digital, conciliación bancaria y mucho más, todo dentro de Digital Box.",
    tsPayOnboardingBannerLandingBottomText2: "Accede gratuitamente a los servicio de TS Pay.",
    tsPayOnboardingLandingTitle: "Descubre las ventajas de la integración entre Digital Box y los servicios de TS Pay.",
    tsPayOnboardingLandingP1: "La {collabText} con las empresas nunca ha sido así de sencilla y segura.",
    tsPayOnboardingLandingP2:
      "Gestiona las transferencias bancarias para pagar las facturas de los proveedores desde Digital Box, evitando errores: las transferencias emitidas desde Digital Box rellenan los datos de IBAN y los importes automáticamente.",
    tsPayOnboardingLandingP3: "Reduce hasta en un 80% el tiempo y recursos delegando toda la gestión y registro de los pagos a TS Pay.",
    tsPayOnboardingLandingP4:
      "Todos los datos confidenciales de tarjetas y cuentas corrientes se tratan de acuerdo con los más altos estándares de seguridad; todos los servicios de TeamSystem Payments están supervisados ​​por {bankText}.",
    tsPayOnboardingLandingCollabText: "Colaboración",
    tsPayOnboardingLandingBankText: "Banco de Italia",
    tsPayOnboardingLandingFooterTitleText1: "Efectúa y recibe pagos",
    tsPayOnboardingLandingFooterTitleText2: "Automatiza la conciliación bancaria",
    tsPayOnboardingLandingFooterTitleText3: "Predice el flujo de efectivo",
    tsPayOnboardingLandingFooterP1:
      "Con TS Pay puedes pagar la factura de tu asesor de forma automática y rápida, realizar pagos digitales a tus proveedores y solicitar pagos a través de un simple enlace.",
    tsPayOnboardingLandingFooterP2:
      "Reduce las actividades necesarias para asociar las transacciones bancarias con los vencimientos: todo es automático, desde el registro de recibos hasta la conciliación.",
    tsPayOnboardingLandingFooterP3:
      "Gracias a la vinculación de tus cuentas, TS Pay cruza los datos de tu saldo bancario con los de ingresos y gastos, proporcionando una previsión de flujos de caja para los próximos 3 meses.",
    tsPayResendOnboardingMailSuccess: "E-mail enviado con éxito. Revisa tu bandeja de entrada.",
    tsPayResendOnboardingMailError: "Lo sentimos, el envío no ha podido realizarse. Por favor, prueba de nuevo más tarde.",
    tsPayRetryErrorMessage: "Lo sentimos, el proceso no ha podido realizarse.",
  },
  accountingYear: {
    title: "Ejercicios Contables",
    previousBalance: "Saldo del año anterior",
    deferrals: "Aplazamientos",
    createTitleFirst: "¡Hola! Todavía no has abierto un ejercicio contable para {companyName}.",
    createTitleSecond: "¡Ábrelo ahora, solo será un minuto!",
    createDescription: "Introduce los datos y crea el nuevo ejercicio.",
    startLabel: "Fecha de inicio del ejercicio *",
    endLabel: "Fecha final del ejercicio *",
    createAccYearCta: "Crear nuevo ejercicio",
    riscontiTitleActive: "Pagos anticipados",
    riscontiTitlePassive: "Ingreso diferido",
    table: {
      header: {
        year: "Año",
        startDate: "Inicio de ejercicio",
        endDate: "Fin de ejercicio",
        useful: "Útil",
        closedOpened: "Cierre / Apertura",
      },
      all: "Todos",
      open: "Abierto",
      close: "Cerrado",
      select: "Selecciona",
      findDate: "Buscar fecha",
      empty: {
        title: "Sin año contable",
        description: "Para el filtro seleccionado",
      },
    },
    drawer: {
      title: "OPERACIONES DE CIERRE",
      deposits: "DEPÓSITOS",
      total: "total",
      totalPrepaidExpenses: "total pagados por adelantado",
      totalDeferredIncome: "total ingresos diferidos",
      destina: {
        title: "DESTINO ÚTIL",
        linkableBreadcrumb: "Cierre del ejercicio fiscal",
        currentBreadcrumb: "Destino Ùtil",
        causal: "Causal",
        causalType: "Asignación de resultados del ejercicio",
        registrationDate: "Fecha de Registro",
        accountingAccount: "Cuenta contable",
        operatingResult: "Resultado del ejercicio",
        give: "Debe",
        have: "Haber",
        account: "Cuenta",
        addAccount: "Añadir cuenta contable",
      },
    },
  },
  deadlines: {
    title: "Vencimientos",
    widgetAccountantTitle: "Plazos fiscales y de Seguridad Social ",
    addDeadline: "Añadir nuevo vencimiento",
    widgetTitle: "Próximos vencimientos",
    myDeadlines: "Mis vencimientos",
    fiscalCode: " / NIF ",
    goBack: "Volver al inicio",
    noPermissionsGoBack: "Ir atrás",
    goClientList: "Volver a la ficha de cliente",
    invoiceFrom: "Factura recibida de ",
    invoiceTo: "Factura emitida a ",
    showDetail: "Ver detalles",
    deadlineDate: "Fecha *",
    deadlineDateNew: "Fecha",
    deadlineDateColumn: "Fecha vencimiento",
    deadlineStatus: "Estado",
    collect: "Enlazar",
    pay: "Pagar",
    collected: "Enlazada",
    to_be_collected: "Pendiente",
    rejected: "Rechazado",
    amount: "Importe",
    amountEuro: "Importe (€)",
    amountNotValid: "Importe no válido",
    amountToCollect: "Importe pendiente",
    amountToPaid: "Importe a pagar",
    amountToPay: "Importe pendiente",
    residueText: "Vencimiento restante",
    unpaid: "No pagado",
    paid: "Pagado",
    due: "Vencido",
    failed: "Fallido",
    tocollect: "Pendiente",
    authorized: "Autorizado",
    notAuthorized: "No autorizado",
    compensation: "Compensazione",
    rebate: "Prima",
    hideDeadline: "Ocultar vencimiento",
    showDeadline: "Mostrar en lista",
    effective: "Efectivo",
    customers: "¿Para qué empresa quieres crear la solicitud?",
    insertCounterpart: "Introducir la contraparte",
    suspended: "Suspendida",
    buttonTSPayMultiple: "Paga {amount} con TS Pay",
    balanceModalCopy: "Todavía no tienes ninguna cuenta vinculada. Continúa con la vinculación de cuentas a continuación.",
    linkedDocEmpty: "No existe ningún documento vinculado al vencimiento.",
    // paymentOutcomePending: "La solicitud de pago con TS Pay se ha enviado a la cuenta {accountNumber} del banco {bankAccountName} el {paymentDate}",
    paymentOutcomePending: "La solicitud de pago con TS Pay se ha enviado el {paymentDate}",
    paymentOutcomeDone: "El importe pendiente ha sido saldado el {paymentDate} con",
    paymentOutcomeCharged: "El importe pendiente se ha saldado el {paymentDate} con",
    // paymentOutcomeFailed: "El pago ha sido rechazado. Comprueba la cuenta {accountNumber} del banco {bankAccountName}.",
    paymentOutcomeFailed: "El pago ha sido rechazado. Comprueba tu cuenta.",
    renewConsent: "Renovar consentimiento para vincular cuenta",
    availableBalance: "Saldo disponible",
    consentExpired: "Consentimiento caducado",
    addAccount: "Agregar una cuenta",
    addAccountTsPay: "Vincular una cuenta corriente al servicio TS Pay",
    subTitleTsPayStudio: "Gestiona los plazos de tus clientes con la fusión de plazos, suspende y crea nuevos plazos personalizados.",
    subTitleTsPayClient: "Mantén los plazos bajo control, planifica y paga con TS Pay.",
    balance: "Saldo",
    amount: "Balance",
    accounts: "Conti",
    header: {
      titleAccountant: "Planifica y consulta los plazos de tus clientes",
      titleClient1: "Planificar y controlar",
      titleClient2: "todo tus",
      titleClient3: "plazos",
      amount: "Saldo",
      subtitle: "Gestiona los plazos de tus clientes con la fusión de plazos, suspende y crea nuevos plazos personalizados.",
      subtitlePay: "Manten los plazos bajo control, planifica y paga con TS Pay.",
    },
    export: {
      csv: {
        button: "Exportar CSV",
        title: "Exportar plazos en formato CSV",
        download: "Descarga ahora los {num} plazos más recientes",
        email: "Envíame todos los plazos por correo electrónico",
        tip: "En ambos casos, la lista está sujeta a los filtros de búsqueda que hayas establecido.",
      },
    },
    noPermissions: "Los detalles de este plazo no están disponibles. Para más información, ponte en contacto con tu asesor.",
    adviceAmountNotValid: "El importe del pago no puede superar al importe del plazo",
    adviceTransformation: "Los plazos actualizados se encuentran en el documento:",

    split: {
      advice: "Este plazo se dividió en 2 o más partes.",
    },
    tooltips: {
      addNewDeadline: "Añadir un nuevo plazo",
    },
    compensation: {
      describe: "compensación",
      description3ko: "Le scadenze non sono state compensate per un errore imprevisto. Riprovare più tardi.",
    },
    merge: {
      buttonConfirm: "Agrupar o compensar",
      buttonConfirmGroup: "Agrupar",
      buttonConfirmCompensation: "Compensar",
      tooltipDisableButton: "Para activar estas funciones, aplica un filtro por descripción o contrapartida ",
      buttonCancel: "Anular",
      save: "Guardar el plazo",
      disabledCheckbox: "Sólo es posible agrupar cuentas por pagar o por cobrar en un estado de pago o de cobro",
      disabledCheckboxForDifferentCompany: "Sólo se pueden seleccionar plazos de la misma empresa",
      titleMerge: "Grupo de plazos seleccionados",
      titleCompensation: "Compensar los plazos seleccionados",
      titleStep2: "Crear nueva fecha de vencimiento",
      titleStep3: "Resumen de plazos",
      allDeadlines: "Ir a todos los plazos",
      residual: "Remanente",
      deadlineTotalAmount: "Total plazo",
      deadlineDateNew: "Fecha de vencimiento",
      deadlineDateCompensation: "Fecha de la compensación",
      step1: "Selección",
      step1c: "Compensación",
      step2: "Nuevo plazo",
      step3: "Fin",
      btnCompensation: "Compensar",
      description1: "Confirmar las selecciones realizadas o cancelar y repetir la operación",
      description2: "Crea una nueva fecha límite para reemplazar las seleccionadas. La información principal del plazo original se almacenará en el historial",
      description3: "Se ha creado el nuevo plazo",
      description3Zero: "Los plazos han sido compensados",
      description3ko: "Los plazos no se han agrupado debido a un error inesperado. Por favor, inténtalo más tarde",
      placeholderDescription: "Por favor, introduce una descripción para el nuevo plazo",
      placeholderPayment: "Por favor, selecciona la forma de pago para el nuevo plazo",
    },
    reconciliation: {
      title: "Conciliación bancaria",
      filterTitle: "Filtrar los plazos",
      searchCounterpart: "Buscar contrapartida",
      movementsBiggerHeader:
        "El importe del movimiento ({registeringAmountMovements} €) es superior que el total de los plazos asociados ({totalAmountToCover} €).",
      deadlinesBiggerHeader:
        "El importe del movimiento ({registeringAmountDeadlines} € de {deadlineDate}) no cubre el total de {totalAmountDeadlines} € de los plazos seleccionados.",
      reconciliationAlert: "El movimiento bancario ya no está asociado a este plazo",
      choice: "Elegir el plazo a dividir:",
      choiceRebate: "Elige el plazo del que se cargará el remanente:",
      invalidSelectionDeadlines: "Aviso, los plazos que has seleccionado no coinciden con el movimiento",
      invalidSelectionDeadlinesDescription: "Comprueba que has hecho la selección correcta",
      reconciledSummaryText: "Tienes {movementsNum} movimientos conciliados y {notReconcilableNum} no conciliados {toRegisterString}",
      reconciledSummaryCta: "Reconciliar ahora",
      registrationAllCta: "Todas las cuentas",
      registrationSelectedCta: "Cuentas seleccionadas",
      selectAllCta: "Seleccionar todo",
      deselectAllCta: "Desmarcar todo",
      closeCta: "Cerrar",
      showOtherMovements: "Mostrar otros movimientos",
      hideOtherMovements: "Ocultar otros movimientos",
      registration: {
        accountingReason: "Causa contable",
        accountingAccount: "Cuenta contable",
        debit: "Debe",
        credit: "Haber",
        debitSuppliers: "Cuentas a pagar a proveedores",
        bank: "Banco",
        accountCta: "Cuenta",
        payment: "Pago",
        receipt: "Recibo",
      },
    },
    payment: {
      /** si è deciso a passare da MPxx a PMxx per distinguere dai pagamenti fattura di origine */
      PMXA: "Compensación",
      PM01: "Contado",
      PM02: "Cheque",
      PM03: "Giro bancario",
      PM04: "Efectivo en Tesorería",
      PM05: "Transferencia bancaria",
      PM06: "Giro postal",
      PM07: "Bolentín bancario o postal",
      PM08: "Tarjeta de pago",
      PM09: "RID",
      PM12: "RIBA",
      PM13: "MAV",
      PM14: "Justificante de pago",
      PM15: "Transferencia a cuentas contables especiales",
      PM16: "Domiciliación bancaria o postal",
      PM19: "SEPA",
      PM22: "Retenciones a cuenta",
      PM23: "PagoPA",
      PMXC: "Débito en cuenta corriente",
    },
    frequency: {
      P1W: "Todas las semanas",
      P2W: "Cada dos semanas",
      P1M: "Todos los meses",
      P2M: "Cada dos meses",
      P3M: "Cada tres meses",
      P4M: "Cada cuatro meses",
      P6M: "Cada seis meses",
      P1Y: "Cada año",
    },
    widget: {
      taxRegime: "Régimen fiscal",
      showAll: "Todos los plazos",
      customer: "Cliente ",
      customers: "Clientes ",
      noDeadlines: "¡No hay plazos próximos!",
      noDeadlinesAccountant: "No hay plazos de impuestos y Seguridad Social",
    },
    pages: {
      calendar: {
        other: "Otros",
        monthView: "Volver a la vista mensual",
        noDataWithFilters: "No hay plazos con los filtros seleccionados",
      },
      table: {
        irpef: "IRPF",
        irap: "IRAP",
        ires: "IS",
        imu: "IBI",
        tasi: "TASI",
        ivs: "IVS",
        f24: "F24",
        f23: "F23",
        ivaDownPayment: "Anticipo de IVA",
        ivaPayment: "Pago de IVA",
        fiscalSocialSecurity: "Impuestos y seguridad social'",
        credit: "Créditos",
        debt: "Deudas",
        rent: "Renta",
        insurance: "Seguro",
        studioReminder: "Memorándum de estudio",
        car: "Coche",
        financing: "Financiación",
        recurring_fees: "Cuota periódica",
        itemPays: "Cliente",
        managerPays: "Delegación en la empresa",
        managerCharge: "Delegación a la empresa en la cuenta del cliente",
        itemCollect: "A favor del cliente",
        notPaid: "No pagado",
        due: "A pagar",
        buttonPaymentsAndCollects: "Cobros y Pagos",
        pending: "En pago",
        tspay_paying: "En pago con TS Pay",
        toCash: "A cobrar",
        rebated: "Rebajado",
        suspended: "Suspendido",
        archived: "Archivado",
        RF01: "Ordinario",
        RF02: "Contribuyentes mínimos",
        RF03: "Nuevas iniciativas empresariales",
        RF04: "Agricultura, actividades conexas y pesca",
        RF05: "Venta de sal y tabaco",
        RF06: "Comercio de partidos",
        RF07: "Publicación",
        RF08: "Gestión de los servicios telefónicos públicos",
        RF09: "Reventa de documentos de transporte público y aparcamiento",
        RF10: "Entretenimiento, juegos y otras actividades contempladas en la tarifa anexa al Decreto Presidencial 640/72",
        RF11: "Agencias de viajes y turismo",
        RF12: "Agriturismo",
        RF13: "Ventas a domicilio",
        RF14: "Reventa de bienes de segunda mano, obras de arte, antigüedades u objetos de colección",
        RF15: "Agencias de subastas de arte, antigüedades u objetos de colección",
        RF16: "IVA de caja RECC.",
        RF17: "IVA de caja",
        RF18: "Otros",
        RF19: "Régimen de tarifa plana",
        company: "Empresa",
        title: "Descripción",
        paymentMinusDate: "Fecha de pago",
        paymentPlusDate: "Fecha de cobro",
        paymentTypePlus: "Modo de cobro",
        paymentTypeMinus: "Modo de pago",
        mode: "Modo",
        handle: "Gestión",
        delegation: "Delegación",
        counterpart: "Contrapartida",
        status: "Estado",
        viewed: "Leído",
        noResults: "No hay resultados",
        solicitDeadline: "Fecha límite de solicitud",
        verifiedPaymentPaid: "Pago verificado: pagado",
        verifiedPaymentNotPaid: "Pago verificado: no pagado",
        solicitConfirmTitle1: "Al confirmar, enviarás una notificación automática a la empresa ",
        solicitConfirmTitle2: " para recordarles este plazo.",
        solicitConfirmHide: "No volver a mostrar la solicitud de confirmación",
        settings: "Ajustes",
        usersSettings: "Permisos de usuario",
      },
      create: {
        typeOfFrequency: "¿Qué tipo de plazo quieres crear? *",
        type: "Elige el tipo de plazo",
        startDate: "Fecha de inicio *",
        finalDate: "Fecha de finalización *",
        frequency: "El plazo se repite",
        deadlinesPreview: "Vista previa de los plazos",
        previewText1: "Vista previa de ",
        previewText2: " plazos de la serie",
        payment: "Pago",
        details: "Detalles",
        goBack: "Ir a los plazos",
        title: "Crear un plazo",
        save: "Crear plazo",
        amount: "Cantidad",
        amountDeadlines: "Cantidad a pagar",
        amountRata: "Importe de la cuota",
        deadlineType: "¿En qué área quieres crear el plazo? *",
        deadlineCounterpart: "Nombre y apellidos o razón social *",
        counterpartPlaceholder: "Por favor, introduce el nombre o la razón social de la contraparte",
        fiscalCodePlaceholder: "Por favor, introduce la Identificación fiscal de la contraparte",
        deadlinePIVAPlaceholder: "Por favor, introduce el Número de IVA de la contraparte",
        companySelect: "Selecciona un cliente",
        companyList1: "Crea un nuevo pago para ",
        companyList2: " Los campos marcados con un asterisco (*) son obligatorios.",
        single: "Único",
        recurring: "Recurrente",
        fiscalCode: "Identificación fiscal *",
        savingTitle1: "Guardado en curso.",
        savingTitle2: "Por favor, espera.",
        saveModalError1: "Por favor, introduce el código ",
        saveModalError2: " o el ",
        saveModalError3: " de la contraparte.",
      },
      detail: {
        repeats: "Si ripete",
        until: " fino al ",
        confirmAuthorization: "Confirmar autorización",
        authorizeDialogText1: "Si autoriza a la empresa ",
        authorizeDialogText2: " para realizar el pago, se cobrará el importe de ",
        authorizeDialogText3: " en la c/c ",
        authorizeDialogText4: " de la empresa",
        confirmQuestion: "¿Confirmar?",
        authorize: "Autorizar",
        dontAuthorize: "No autorizar",
        dontAuthorizePayment: "No autorizar el pago",
        reject: "Rechazar",
        notAuthorizedDialogText1: "Si no lo autoriza la empresa ",
        notAuthorizedDialogText2: " al hacer el pago, te arriesgas a incurrir en sanciones.",
        notAuthorizedDialogText3: "¿Seguro que quieres denegar la autorización?",
        confirmRejection: "Confirmación de denegación de pago",
        addNote: "¿Deseas añadir un comentario?",
        saveNote: "Guardar comentario",
        refuseMessage1: "Si te niegas a realizar el pago, te arriesgas a incurrir en sanciones.",
        refuseMessage2: "Si lo confirmas, tu empresa ",
        refuseMessage3: " será notificada.",
        refuseMessage4: "¿Estás seguro de que no quieres pagar este plazo?",
        addStudioComment: "Añadir un comentario para la empresa",
        registerPayment: "Registrar pago",
        registerPaymentWithTsPay: "Pago por transferencia bancaria",
        registerPaymentWithTsPay2: "Pagar con",
        limitTipTsPayPayment: "Con Ts Pay puedes pagar cantidades hasta {limit}",
        sendTsPayMail: "Solicitud de pago con",
        registerCollect: "Registro de ingresos",
        newDeadlineResidue: "Crear un nuevo plazo",
        dontPay: "No pagar",
        suspend: "Suspender",
        active: "Reactivar el plazo",
        register: "Registro",
        registerSuccess: "Pago registrado con éxito",
        paymentDate: "Fecha de pago",
        saleDate: "Data incasso",
        deadlineDate: "Fecha del plazo",
        registerPaymentAmountZero: "Introduce el importe superior a 0",
        registerPaymentDifferentToZero: "Introduce el importe distinto de 0",
        registerIsSplitting: "Crear un nuevo plazo a partir de restantes en curso.",
        paymentType: "Formas de pago",
        hiddenDeadline: "Fecha del plazo oculta",
        visibleDeadline: "Tu plazo es ahora visible en la lista",
        collected: "Recuperado",
        toCollect: "A cobrar",
        reconciledDeadline: "Fecha límite de conciliación",
        itemPaysSentence1: "El importe sólo puede abonarse a través de los servicios telemáticos de la Agencia Tributaria.",
        itemPaysSentence2: "El importe puede pagarse a través de los servicios telemáticos de la Agencia Tributaria o de los servicios bancarios por Internet",
        managerPaysSentence1: "El importe será pagado, según lo autorizado por el cliente, directamente por la empresa.",
        managerPaysSentence2: "El importe será pagado, según su autorización, directamente por la empresa.",
        managerChargeSentence1: "El importe se cobrará, según lo autorizado por el cliente, directamente ",
        managerChargeSentence2_1: "en la cuenta bancaria con el código IBAN ",
        managerChargeSentence2_2: "en su cuenta bancaria",
        managerChargeSentence3: "El importe se cobrará, según su autorización, ",
        modifiedDate: "Modificado el ",
        totalDeadlinesAt: "Total de plazos de ",
        hiddenDeadlineDetail:
          "Desde este icono se puede restablecer el plazo más adelante. Puedes ver los plazos ocultos del calendario activando la opción de ver los plazos ocultos.",
        paidOffDeadline1: "El plazo está pagado ",
        paidOffDeadlineDeterminative: "el ",
        paidOffDeadline2: " con ",
        rejectedPayment: "El pago fue rechazado el ",
        reminderSent: "Has enviado un recordatorio: ",
        showMore: "Mostrar más",
        showLess: "Mostrar menos",
        tab1: "Detalles",
        tab2: "Comentarios",
        tspay: {
          title: "Pagar con TS Pay",
          stepper1: "Tu cuenta",
          stepper2: "Beneficiario",
          stepper3: "Pagar",
          warnings: {
            account: "Selecciona una cuenta de pago de vencimiento",
            name: "Introduce el nombre del beneficiario",
            iban: "Introduce el IBAN del beneficiario",
            date: "Introduce la fecha de pago",
          },
          payment: {
            mainbox: {
              title: "Datos de pago",
            },
            sidebox: {
              title: "Resumen",
            },
          },
          content1: {
            title: "Estás pagando los plazos seleccionados",
            amount: "Importe total",
            accounts: "Selecciona la cuenta",
            noAccounts: "No se ha encontrado ninguna cuenta",
            insufficient: "Disponibilidad insuficiente",
          },
          content2: {
            name: "Nombre y apellidos del beneficiario",
            iban: "IBAN",
            date: "Fecha de pago",
          },
          content3: {
            summary: "Resumen de pagos",
          },
          content4: {
            feedback: "Pago registrado con éxito",
          },
        },
      },
    },
    table: {
      deadlineDate: "Data scadenza",
      company: "Azienda",
      counterpart: "Controparte",
      description: "Descrizione",
      amount: "Importo",
      paymentMode: "Modalità di pagamento",
      management: "Gestione",
      status: "Stato",
      isRead: "Letto",
      planned: "Pianificate",
      hidden: "Nascoste",
      onlyHidden: "Solo scadute",
      allAreas: "Tutti gli ambiti",
      total: "Totale",
      deadlines: "scadenze",
      deadline: "scadenza",
      otherPlanned: "{total} scadenze pianificate",
    },
  },
  documents: {
    title: "DOCUMENTOS",
    download: "Descargar documento",
    downloading: "Descarga en curso",
    addCommentTooltip: "Añadir un comentario",
    showMore: "Ver más resultados",
    visibleStudioOnly: "Visible sólo en tu asesoría",
    crypted: "Documento cifrado",
    noPreview: "No es posible previsualizar este documento",
    noPreviewDesc: "Para ver el contenido, debe descargar el archivo y abrirlo",
    noDocuments_1: "Para",
    noDocuments_2: "todavía no hay documentos",
    noResults_1: "Lo sentimos, no se han encontrado resultados para",
    noResults_2: "Inténtalo de nuevo con otro término de búsqueda",
    noResults_filtered: "No hay documento para el filtro seleccionado",
    searchLabel: "Qué buscas hoy",
    searchPlaceholder:
      "Busca por palabra clave, categoría, fecha, tipo de documento, cliente, número de factura, importe y mucho más. Introduce al menos 3 caracteres.",
    upload: "Cargar un nuevo documento",
    onlyUnread: "Solo sin leer",
    linkedTo: "Documento vinculado a",
    preview: {
      placeholder: "Modelo gráfico:",
      previewDoc: "Vista previa del documento",
      xml: "Vista previa XML",
      ae: "Vista previa de la Agencia Tributaria",
    },
    filters: {
      cancel: "Limpiar los filtros",
      date: "Fecha",
      filterFor: "Filtrar por",
      others: "Otros filtros",
      selectPeriod: "Selecciona el período",
      invoiceTypology: "Tipo de factura",
      selectMonths: "Selecciona los meses",
      month: "Mes",
      quarter: "Trimestre",
      semester: "Semestre",
      fromDate: "Fecha de inicio",
      toDate: "Fecha final",
      typeDate: {
        documentLess: "Fecha del primer documento",
        createLess: "Carga anterior",
        documentMore: "Fecha del último documento",
        createMore: "Carga más reciente",
        importLess: "Importe menor",
        importMore: "Importe mayor",
        document: "Documento",
        create: "Cargando",
        order: "Ordenar por",
        scoreLess: "Correspondencia mayor",
        scoreMore: "Correspondencia menor",
      },
      otherFilters: {
        "Le tue etichette": "Tus etiquetas",
        "Tipo documento": "Tipo de documento",
        Categoria: "Categoría",
      },
      macroCategory: {
        Inbox: "Bandeja de entrada",
        Altri: "Otros",
        Fatture: "Facturas",
        Fiscale: "Fiscal",
        Azienda: "Empresa",
      },
    },
    toTranslate: {
      "Non specificato": "No especificado",
      "Data caricamento": "Fecha de subida",
      "Nome file": "Nombre del fichero",
      Importo: "Importe",
      "Periodo imposta": "Periodo impositivo",
    },
    detail: {
      title: "VISTA PREVIA DEL DOCUMENTO",
      classificator: "Cambiar la clasificación",
      visibleByStudioOnly: "Visible sólo en tu asesoría",
      visibleByAll: "Visible para todos",
      tab1: "Detalle",
      tab2: "Comentarios",
      attachmentSectionTitle: "Anexos",
      linkedDocumentsSectionTitle: "Documentos vinculados",
      manage: "Gestionar",
      linkedDocModalTitle: "Vincular documentos",
      linkedDocModalCancelButton: "Cancelar",
      linkedDocModalSaveButton: "Guardar",
      linkedDocEmpty: "Por el momento no hay ningún documento vinculado.",
      attachmentEmpty: "Por el momento, no hay ningún vínculo.",
      accuracy: "Correspondencia",
      infoSectionTitle: "Información",
      nameSectionTitle: "Nombre del archivo",
      originalName: "Nombre original",
      errorTitle: "No se puede renombrar",
      errorMessageNoCharacter: "El nuevo nombre del archivo debe contener al menos un nuevo carácter.",
      errorMessageInternalServerError: "Lo siento, el proceso ha fallado. Por favor, inténtalo más tarde",
      errorMessageDifferentFilename: "El nombre del archivo debe ser diferente del nombre actual",
      nameInputPlaceholder: "Introduce el nombre del hilo",
      status: "Estado",
      otherSectionTitle: "Más",
      modifyDeadlines: "Gestión de plazos",
      uploader: "Cargado por",
      folder: "Añadir al expediente",
      recipientDeliveryDate: "Entregado al destinatario",
      recipientAvailableDate: "Poner a disposición del destinatario",
      receiptDate: "Recibido por la SDI",
      sdiDeliveryDate: "Entregado a la SDI",
      paRejected: "Rechazado por el destinatario",
      paEffectiveDate: "Factura debidamente emitida por expiración de los plazos",
      paAccepted: "Aceptado por el destinatario",
      inputPlaceholder: "Intruduce el nombre del documento",
      toFolder: "para archivar",
    },
    tooltips: {
      addNewDocument: "Añadir un nuevo documento",
    },
    headerTitle: {
      firstPart: "Todos tus documentos",
      boldPart: "en un solo lugar",
      secondPart: "siempre en orden.",
    },
    headerSubtitle: {
      boldPart: "Encuentra tus documentos",
      secondPart: "navegar por las macrocategorías, filtrar con etiquetas, selección temporal o hacer una búsqueda de texto con palabras clave.",
      bisPart: "Si no encuentras lo que necesitas, ",
      bisLinkPart: "Comprar un documento",
    },
    dictionary: {
      macrocategory: "Categoría",
      microcategory: "Subcategoría",
      category: "Descripción",
      ditta_cf: "Código fiscal de la empresa",
      ditta_nome: "Nombre de la empresa",
      ditta_denominazione: "Nombre de la empresa",
      ditta_piva: "NIF/IVA de la empresa",
      fiscale_periodo_al: "Fecha final de referencia",
      idobject: " ID de knos de la publicación",
      info_file: "Nombre del archivo",
      time_stamp: "Cronología",
      utente_nome: "Usuario",
      documento_tipo: "Descripción",
      fiscale_periodo_anno: "Período del año fiscal",
      trasmesso_cod: "Código transmitido",
      protocollo_attribuito: "Protocolo atribuido",
      progressivo_invio: "",
      esito: "Resultado",
      file: "Nombre del archivo",
      ambiente: "Entorno",
      ditta_codice: "Código de empresa",
      data_ricezione: "Fecha de recepción",
      doc_codice: "Código del documento",
      doc_subcodice: "Subcódigo del documento",
      doc_descrizione: "Descripción del documento",
      fiscale_periodo_dal: "Período fiscal de salida",
      start: "Inicio",
      cod_au: "Código de registro único",
      id_anagrafica: "Id del registro",
      cf_intermediario: "Código fiscal intermediario",
      fiscale_data_vers: "Fecha de pago",
      fiscale_periodo_periodo: "Año de referencia",
      fiscale_data_doc: "Fecha del documento",
      doc_numero: "Número de documento",
      doc_serie: "Código de sección del registro de IVA",
      doc_serie_descrizione: "Descripción de sección del registro de IVA",
      "documento.tipo": "Descripción",
      progre: "Documento progresivo",
      cod_cli: "Código cliente",
      cliente: "Nombre del cliente",
      descrizione_cli: "Descripción adicional del cliente",
      piva_cli: "NIF/IVA del cliente",
      cfis_cli: "NIF del cliente",
      cod_for: "Código del proveedor",
      fornitore: "Nombre del proveedor",
      descrizione_for: "Descripción adicional del proveedor",
      piva_for: "NIF/IVA del proveedor",
      cfis_for: "NIF del proveedor",
      trasmesso_nome: "Nombre del transmisor",
      num_accolte: "Declaraciones aceptadas",
      num_pagamenti: "Número de pagos",
      num_scartate: "Número de descartes",
      num_trasmissioni: "Número de transmisiones",
      vers_positivo: "Pagos positivos",
      vers_zero: "Pagos con importe 0",
      utente_id: "ID de usuario",
      filiale_cod: "Código de sucursal",
      filiale_desc: "Descripción de sucursal",
      mat_inps_ditta: "Número de matrícula del INPS",
      mese_cod: "Número de mes",
      mese_desc: "Descripción del mes",
      mat_dip: "Número de matrícula del trabajador",
      cognome_nome_dip: "Apellido y nombre del trabajador",
      cod_fiscale_dip: "NIF del trabajador",
      comune_dip: "Municipio de residencia del trabajador",
      data_ass: "Fecha de contratación del trabajador",
      qualifica_cod: "Código de cualifiación del trabajador",
      qualifica_desc: "Descripción de la cualificación del trabajador",
      registro: "Código de registro",
      num_pag_i: "Página de registro",
      annullato: "Contiene la página anulada",
      pos_inail_ditta: "Posición Inail empresa",
      data_cess: "Fecha de terminación del trabajador",
      cod_centro_costo: "Código del centro de costes",
      centro_costo: "Descripción del centro de coste",
      cod_reparto: "Código del centro de departamento",
      "status.name": "Estado",
      lynfa: "Ts Studio",
      "dati riepilogo.0.imponibile Importo": "Resumen de datos de la línea 1 Base imponible",
      "dati riepilogo.0.imposta": "Resumen de datos línea 1 de impuestos",
      "dati riepilogo.0.arrotondamento": "Resumen de datos linea 1 redondeo",
      "dati pagamento.0.condizioni pagamento": "Datos de pago línea 1 condiciones de pago",
      "dati pagamento.0.codice modalita pagamento": "Datos de pago línea 1 código de la forma de pago",
      "dati pagamento.0.modalita pagamento": "Datos de pago línea 1 forma de pago",
      "dati pagamento.0.importo pagamento": "Datos de pago línea 1 importe de pago",
      importo: "Importe",
      provenienza: "Procedencia",
      anno: "Año",
      dataversamento: "Fecha de pago",
      codicefiscaledestinarario: "CIF Destinatario",
      cedenteprovincia: "Provincia de origen",
      idpaesedestinatario: "ID del país del destinatario",
      codicedestinatario: "Código destinatario",
      datadocumento: "Fecha Documento",
      datainviosdi: "Fecha de envio SDI",
      cognomedestinatario: "Apellidos Destinatario",
      cedentenazione: "País de origen",
      datiriepilogo: "Resumen de datos",
      nomedestinatario: "Nombre Destinatario",
      denominazionedestinatario: "Nombre Fiscal",
      dataconsegnamessaadisposizionedestinatario: "Fecha de entrega/ puesta a disposición del destinatario",
      codicetipodocumento: "Código tipo de documento",
      dataregistrazione: "Fecha de registro",
      numeroregistrazione: "Número de registro",
      codicefiscalecontroparte: "CIF Contraparte",

      paginafinale: "Página final",
      paginainiziale: "Página inicio",
      periododiriferimento: "Periodo referencia",
      sezionale: "Sección",
      tipodichiarazione: "Tipo Declaración",
      datadichiarazione: "Fecha Declaración",
      denominazionesoggetto: "Nombre de la empresa",
      codicefiscalesoggetto: "NIF de la empresa",
      datainzio: "Fecha Inicio",
      numero: "Número ",
      datadocumento: "Fecha documento",
      periododiriferimento: "Periodo referencia ",
      datadiscadenza: "Fecha de validez",
      denominazionedelcontraente: "Nombre del contratante",
      codicefiscaledelcontraente: "NIF del contratante",
      partitaivadelcontraente: "NIF/IVA del contratante",
      domicilio: "Domicilio",
      modalitàdipagamento: "Forma de pago",
      targadelveicolo: "Matrícula vehículo",
      tipodelveicolo: "Tipo vehículo",
      classedimerito: "Bonificación",
      perdiododiriferimento: "Periodo referencia",
      datascadenza: "Fecha Vencimiento",
      idcomunicazione: "ID Comunicación",
      codiceatto: "Código Administración",
      datatrasmissionetelematica: "Fecha de transmisión telemática",
      codicefiscaledestinarario: "CIF Destinatario",
      cognomedestinatario: "Apellidos Destinatario",
      dataemissione: "Fecha emisión",
      denominazionedestinatario: "Nombre Fiscal",
      idpaesedestinatario: "ID del pais del receptor",
      importo: "Importe",
      nomedestinatario: "Nombre Comercial",
      numerodocumento: "Número Documento",
      partitaivadestinatario: "NIF/IVA Destinario",
      codicefiscalefornitoremittente: "Código Fiscal Proveedor (Remitente)",
      cognomefornitoremittente: "Apellidos Proveedor (remitente)",
      datadiregistrazione: "Fecha registro",
      denominazionefornitoremittente: "Nombre proveedor (remitente)",
      idpaesefornitore: "ID del país del proveedor",
      nomefornitoremittente: "Nombre del proveedor (remitente)",
      partitaivafornitoremittente: "NIF/IVA Proveedor (remitente)",
      cognome: "Apellidos",
      nome: "Nombre",
      entecheharilasciatoildocumento: "Organismo que expide el documento",
      tipoformato: "Tipo Formato",
      matricola: "Código ¿?",
      sostitutodimposta: "Representante",
      datatrasmissionetelematicadataditrasmissione: "Fecha de transmisión telemática / Fecha de transmisión",
      descrizionedocumento: "Descripción Documento",
      denominazionedeltrasportatore: "Nombre del transportista",
      codicefiscaledeltrasportatore: "CIF del transportista",
      partitaivadeltrasportatore: "NIF/IVA del transportista",
      denominazionecontroparte: "Nombre Contraparte",
      codicefiscalecontroparte: "CIF Contraparte",
      partitaivacontroparte: "NIF/IVA Contraparte",
      duratadelcontratto: "Duración del contrato",
      tipologiadicontratto: "Tipo de contrato",
      oggettodelcontratto: "Objeto del contrato",
      codiceidentificativo: "Código Identificación",
      destinatariodeldocumentocomunicazione: "Destinatario del documento/ Comunicación",
      iddocumentonelsistemadellamministrazione: "ID Documento en el sistema de la Administración",
      idfascicolonelsistemadellamministrazione: "ID del fichero en el sistema de la Administración",
      identificativoamministrazione: "Identificador de la Administración",
      identificativoaoo: "Identificador AOO",
      mittentedeldocumentocomunicazione: "Remitente del documento/ Comunicación",
      progressivoprotocollo: "Protocolo Progresivo",
      numerodiregistrazione: "Número de registro",
      ufficiodiregistrazione: "Oficina de registro",
      denominazione: "Denominación",
      codicefiscale: "NIF",
      oggettodellaconvocazione: "Objeto de la convocatoria",
      numeroregistrazione: "Número de registro",
      cedentenazione: "País de origen",
      cedenteprovincia: "Provincia de origen ",
      datiriepilogo: "Resumen de datos",
      numeroprogressivoprogressivoinvio: "Número de serie",
      stato: "Estado",
      dataconsegnamessaadisposizionealdestinatario: "Fecha de entrega/ puesta a disposición del destinatario",
      codiceidentificativoclassificazione: "Código de Identificación (clasificación)",
      cognomedellinteressato: "Apellidos del Interesado",
      protocolloserviziotelematicodoganale: "Protocolo Servicio telemático de aduanas",
      soggettodelegato: "Sujeto delegado",
      soggettoobbligato: "Sujeto pasivo",
      datadellinventario: "Fecha de inventario",
      tipodiinventario: "Tipo de inventario",
      modalitaditrasmissione: "Modalidad de presentación",
      ente: "Entidad",
      controparte: "Contraparte",
      codicedocumento: "Código documento",
      eserciziofiscale: "Ejercicio Fiscal",
      datadichiusuracreazione: "Fecha de cierre (creación)",
      idfilelog: "ID log archivo",
      idlog: "ID Log",
      improntahashdocumento: "Huella digital (hash) del documento",
      soggettoid: "ID Asunto",
      utenteid: "ID de usuario",
      casellapecmail: "Buzón Correo / Correo Certificado",
      datamessaggiopecmail: "Fecha Mensaje correo / Correo certificado",
      idmessaggiopecmail: "ID Mensaje correo / Correo certificado",
      oggettomessaggiopecmail: "Asunto del mensaje correo / Pec",
      tipologiacontratto: "Tipo de contrato",
      codicematricoladipendentetrasferta: "Código de trabajador/transferencia",
      cognomedipendentetrasfertista: "Apellidos trabajador desplazado",
      nomedipendentetrasfertista: "Nombre del trabajador desplazado",
      fideiussore: "Garantía",
      riferimentidocumento: "Referencia del documento",
      riferimento: "Referencia",
      comune: "Municipo",
      periododiimposta: "Periodo fiscal",
    },
    delete: {
      title: "Eliminar este documento",
      text: "¿Seguro que quieres eliminar este documento?",
      confirm: "Eliminar documento",
      no: "No",
      feedback: {
        okTitle: "Documento eliminado con éxito",
        okMessage: "Ya no podrás acceder al documento eliminado",
        koTitle: "Se ha producido un error",
        koMessage: "Este documento no se pudo eliminar",
      },
    },
    classificator: {
      title: "CLASIFICACIÓN DE DOCUMENTOS",
      titlePage: "Clasificación",
      step1: "Clasificación",
      step2: "Etiquetas",
      step3: "Guardar",
      back: "Volver a la sección de documentos",
      backAsk: "Volver al detalle de la solicitud",
      tooltip1: "Si no encuentras el tipo de documento que necesitas, haz clic en",
      tooltip2: "AYUDA Soporte",
      tooltip3: "y pide a Soporte que añada la opción que te interesa",
      tags: {
        add: "Añadir etiquetas",
        custom: "Etiquetas personalizadas",
        newName: "Escribe el nombre de la nueva etiqueta",
      },
      feedback: {
        okTitle: "Cambio de clasificación realizado",
        okMessage: "El cambio de clasificación ha sido realizado",
      },
    },
  },
  folders: {
    title: "Expedientes",
    titleCompany: "Mis expedientes",
    folder: "El expediente",
    create: "CREAR UN NUEVO EXPEDIENTE",
    created: "creado",
    edited: "modificado",
    noFolders1: "Organiza la documentación seleccionando documentos ya existentes o subiendo archivos nuevos.",
    noFolders2: "Crea tu primer expediente",
    noFolders3: "No hay expedientes disponibles.",
    allfolders: "Volver a todos los expedientes",
    edit: "EXPEDIENTE",
    backTo: "Volver a los expedientes",
    selection: "Selecciona un expediente para añadir este documento.",
    loading: "Cargando expediente en curso. Por favor, espera.",
    saving: "Guardado en curso. Por favor, espera.",
    deleteConfirm: "¿Confirmas la eliminación del expediente seleccionado?",
    type: "Tipología",
    refYear: "Período de referencia",
    lastUpdate: "Última actualización",
    createdAt: "Fecha de creación",
    custom: "Personalizado",
    contains: "Este expediente contiene",
    onlyStudio: "Visible solo para tu asesoría",
    onlyStudioTooltip: "Si configuras el expediente como visible sólo para tu asesoría, el cliente no lo verá",
    downloading1: "Descargando el expediente en curso.",
    tooltips: {
      addNewFolder: "Añadir un nuevo expediente",
    },
    feedback: {
      delete: {
        ok: "El Expediente se ha eliminado correctamente",
      },
    },
    typology: {
      Personalizzato: "Personalizado",
      Banca: "Banco",
      Bilancio: "Balances",
      Dichiarazioni: "Declaraciones",
      Contenzioso: "Jurídico",
    },
    toast: {
      warning: "Atención",
      noEmptyFields: "Rellenar los campos obligatorios",
    },
    docCategories: {
      unSpecified: "No especificado",
    },
    pages: {
      edit: {
        actions: {
          create: "Crear un expediente",
          update: "Guardar los cambios",
        },
        labels: {
          edit: "Expediente",
          create: "Crear Expediente",
          documents: "Documentos del Expediente",
          name: "Nombre del expediente",
          type: "Tipo",
          period: "Período de referencia",
          attachments: "Documentos anexos",
        },
        types: {
          dossier_1: "Personalizado",
        },
        summary: {
          title: "Estás creando este expediente para",
        },
      },
      list: {
        filters: {
          text: "Búsqueda por nombre o período de referencia",
        },
        table: {
          cols: {
            name: "Nombre del expediente",
            type: "Tipo",
            period: "Período de referencia del expediente",
            createdAt: "Fecha de creación",
            company: "Cliente",
          },
        },
      },
      create: {
        title: "Crear un nuevo expediente para",
        required: ". Los campos con un asterisco (*) son obligatorios.",
      },
      delete: {
        confirm: "Confirma la eliminación",
      },
      share: {
        title: "Comparte este expediente",
        description: "Compartir el enlace de descarga de este expediente",
        copy: "Copiar enlace",
        copied: "¡Enlace copiado!",
        email: "Email",
        modalTitle: "Compartir expediente por e-mail",
        message: "Mensaje",
        placeholder: "Insertar texto opcional que se añadirá al mensaje",
        emailFeedback: "Correo electrónico enviado con éxito",
      },
    },
    header: {
      titleFirstPart: "Crear",
      boldTitle: "expedientes",
      titleSecondPart: "rápida y automáticamente es muy fácil!",
      subtitleFirstPart: "Selecciona",
      boldSubtitle: "añadir un nuevo expediente",
      subtitleSecondPart: "y crea distintas clasificaciones para los documentos de la empresa",
      companyTitle1: "Tu",
      companyTitle2: "expediente",
      companyTitle3: "siempre estará disponible",
      companyTitle4: "al alcance de tu mano.",
      companySubtitle1: "Trabaja ahora con los expedientes preparados por tu asesor.",
    },
    widget: {
      folderDetail: {
        title: "Este expediente contiene los siguientes documentos",
        noDocuments: "No se adjunta ningún documento al expediente",
      },
    },
    filters: {
      new: "Creación más reciente",
      old: "Creación menos reciente",
      update_new: "Actualización más reciente",
      update_old: "Actualización menos reciente",
      az: "A-Z",
      za: "Z-A",
    },
  },
  fulfilments: {
    title: "OBLIGACIONES",
    headerTitle1: "Controla el estado de tus ",
    headerTitle2: "obligaciones.",
    driverButton: "Definir conductor",
    searchFilter: "Encontrar un cliente",
    dateFromFilter: "Desde la fecha",
    dateToFilter: "A la fecha",
    editDialog: "Modificación de la obligación",
    statuses: {
      completed: "Completado el {date}",
      todo: "Faltan {period}",
      expired: "Expirado el {date}",
    },
    list: { addButton: "Añadir obligación" },
    create: {
      titleLeft: "Selecciona la obligación",
      titleLeftManual: "Crear una obligación personalizado",
      titleRight: "Empresas seleccionadas",
      filters: {
        kinds: {
          accounting: "Contables",
          fiscals: "Fiscales",
          management: "Gestión de personal",
          all: "Todos",
        },
      },
    },
  },
  generic: {
    all: "Todos",
    cancel: "Cancelar",
    back: "Volver",
    next: "Siguiente",
    save: "Guardar",
    send: "Enviar",
    export: "Exportar",
    total: "Total",
    days: "Días",
    today: "Hoy",
    tomorrow: "Mañana",
    completed: "Completado",
    undefined: "No definido",
    fiscalCode: "NIF",
    fiscalCodeExtended: "Identificación Fiscal",
    fiscalCodeExtendedSmall: "Identificación fiscal",
    vatNumber: "NIF / IVA",
    vatNumberSmall: "NIF / IVA",
    vatNumberExtended: "NIF / IVA (NIF operador intracomunitario)",
    balance: "Saldo",
    update: "Actualizar",
    businessName: "Nombre de la empresa",
    address: "Dirección",
    notAvailable: "No disponible",
    select: "Selecciona",
    requiredField: "Campo obligatorio",
    title: "Título",
    titlePlaceholder: "Introduce un título",
    titlePlaceholder3char: "Introduce al menos 3 letras",
    description: "Descripción",
    descriptionNotAvailable: "Descripción no disponible",
    textPlaceholder: "Insetar texto",
    summary: "Resumen",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "E-mail",
    selectStudio: "Selecciona una empresa de la lista anterior",
    selectCompanyPlaceholder: "Introduce el nombre de la empresa o el NIF...",
    counterpart: "Contrapartida",
    menu: "Menú",
    manageProfile: "Gestionar perfil",
    changeAccountant: "Cambiar cuenta",
    appDownload: "Descargar la App",
    logout: "Salida",
    goodMorning: "Buenos días",
    active: "Activo",
    notActive: "Inactivo",
    loadingMessage: "Carga en curso. Por favor, espera.",
    loadingMessage2: "Recuperación de información en curso.",
    loadingMessage3: "Por favor, espera.",
    password: "Contraseña",
    request: "Título",
    customer: "Cliente",
    status: "Estado",
    documentsData: "Datos del documento",
    documentDate: "Fecha del documento",
    documentNumber: "Número del documento",
    documentAmount: "Importe del documento",
    counterpart: "Contrapartida",
    counterpartPIVA: "NIF / IVA",
    notifications: "Notificaciones",
    notificationsSettings: "Configuración de las notificaciones",
    first: "Primero",
    second: "Segundo",
    third: "Tercero",
    fourth: "Cuarto",
    copy: "Copia",
    attention: "Atención",
    loading1: "Carga de datos en curso.",
    loading2: "Por favor, espera.",
    operation1: "Operación en curso.",
    operation2: "Espera por favor...",
    saving1: "Guardando.",
    goodMorning: "Buenos días",
    goodEvening: "Buenas tardes",
    yes: "Sì",
    no: "No",
    active: "Attivo",
    notActive: "Non attivo",
    fiscalCodeAbbreviation: "NIF",
    consentYes: "Sí, estoy de acuerdo",
    consentNo: "No, no estoy de acuerdo",
    loadingData1: "Cargando datos",
    loadingData2: "Por favor, espera",
    noSearchCompany: "Sin resultados",
    shortTaxIdentifier: "NIF",
    dates: {
      send: "Fecha de envío",
      fill: "Fecha de recepción",
      receive: "Fecha de recepción",
    },
    rangePicker: {
      shortcut: {
        lastYear: "Último año",
        lastMonth: "Mes",
        lastQuater: "Trimestre",
        lastDay: "Hoy",
      },
    },
    calendar: {
      title: "CALENDARIO",
      today: "Hoy",
      thisWeek: "Esta semana",
      thisMonth: "Este mes",
    },
    months: {
      "01": "Enero",
      "02": "Febrero",
      "03": "Marzo",
      "04": "Abril",
      "05": "Mayo",
      "06": "Junio",
      "07": "Julio",
      "08": "Agosto",
      "09": "Septiembre",
      10: "Octubre",
      11: "Noviembre",
      12: "Diciembre",
    },
  },
  notification: {
    markAllAsRead: "Marcar todo como leído",
    removeAll: "Eliminar todo",
    settings: "Configurar las notificaciones",
    loading: "Cargando...",
    markAsUnread: "Marcar como no leído",
    markAsRead: "Marcar como leído",
    remove: "Eliminar",
    noNotification: "No hay notificaciones",
    refreshNotificationSuggestion: "Para ver las nuevas notificaciones actualiza la página",
    settingsDescription: "Establece tus preferencias para recibir notificaciones de Digital Box.",
    app: "App",
    email: "Email",
    newDocument: "Nuevo documento",
    newComment: "Nuevo comentario",
    askResponse: "Respuesta a una solicitud",
    deadlinesOperation: "Operaciones sobre plazos",
    newAskReceived: "Nueva solicitud recibida",
  },
  profile: {
    title: "PERFIL",
    profile: "Perfil",
    professionalStudies: "Despachos profesionales",
    account: "Cuenta de usuario",
    customers: "Tus clientes",
    noCustomers: "Todavía no tienes clientes",
    unverified: "Completa tu perfil",
    personalArea: "Inicia sesión en tu área personal",
    addressUnregistered: "Dirección no registrada",
    yourAccountants: "Tus contables",
    yourAccountant: "Tu contable",
    noAccountant: "No tienes contable",
    types: {
      accountant: "Asesoría",
      company: "Empresa",
    },
    modifyRegistry: "Modificación del registro",
    modifyPassword: "Cambiar la contraseña",
  },
  settings: {
    title: "CONFIGURACIONES",
    permissions: "Permisos",
    edit: "Editar",
    summary: "Resumen",
    tooManyCompanies: "Atención",
    tooManyCompaniesDescription: "En esta tabla solo se muestran las primeras 100 empresas. Para encontrar las demás, utilice la búsqueda.",
    searchPlaceholder: "Buscar por apellido, nombre o correo electrónico del usuario",
    searchCompanyPlaceholder: "Buscar por nombre de la empresa o NIF",
    company: "Empresa",
    companies: "Empresas",
    clients: "Empresas",
    accountant: "Usuarios",
    users: "Usuarios",
    surname: "Apellido",
    name: "Nombre",
    email: "E-mail",
    usersCompany: "Usuarios de la empresa",
    popoverTitle1: "La empresa",
    popoverTitle2: "puede llevar a cabo las siguientes actividades",
    goToSettingsPage: "Ir a la página de Configuración",
    businessPerformancePermissionsTitle: "Rendimiento de la empresa",
    manageBusinessPerformanceSettings: "Administrar",
    businessPerformanceModalTitle: "Permisos de actuación empresarial",
    businessPerformanceModalContentTitle: "Permisos sobre los indicadores de rendimiento empresarial",
    businessPerformanceModalUserTitle1: "Permisos de ",
    businessPerformanceModalUserTitle2: " sobre los indicadores de rendimiento de la empresa ",
    applyPermissions: "Aplicar",
    resetPermissions: "Cancelar",
    summaryTable: {
      canSeeTitle: "Pueden ver",
      canUploadTitle: "Pueden cargar documentos",
      canDoTitle: "Pueden realizar estas actividades",
      bpClientsTitle: "Rendimiento Empresarial de Clientes",
      bpProvidersTitle: "Rendimiento Empresarial de Proveedores",
      bpPortfolioTitle: "Rendimiento Empresarial de Cartera",
      bpStoreTitle: "Rendimiento Empresarial de Almacén",
    },
    businessPerformance: "Gestionar el Rendimineto Empresarial",
    businessPerformanceSettings: {
      clientsTitle: "Clientes",
      providersTitle: "Proveedores",
      portfolioTitle: "Cartera",
      storeTitle: "Almacén",
    },
    userPermissions: {
      canSeeTitle: "Puede ver",
      canUploadTitle: "Puede cargar documentos",
      canDoTitle: "Puede realizar estas actividades",
      userManagerTitle: "Puede ver y realizar las siguientes actividades",
    },
    feedback: {
      success: {
        title: "Configuración guardada correctamente",
        message: "La configuración se ha guardado correctamente",
      },
      error: {
        title: "Ha ocurrido un problema",
        message: "La configuración no se ha guardado correctamente",
      },
    },
  },
  tspay: {
    payment: {
      mainbox: {
        title: "Datos de pago",
      },
      sidebox: {
        title: "Resumen",
        summaryTipSingle: "Estás pagando",
        summaryTipMultiple: "Estás pagando",
        summaryTipReason: "Motivo",
        summaryTipBeneficiary: "A",
        summaryTipBeneficiaryIban: "IBAN",
        summaryTipDate: "Fecha de pago",
        summaryAmount: "Importe",
      },
      warnings: {
        minReason: "El motivo debe contener al menos 5 caracteres",
      },
    },
  },
  widgets: {
    documentBrowsing: {
      label: "Selecciona uno o varios documentos {existing}",
      label2: "Adjuntar un documento",
      linkedDocLabel: "Documentos*",
      placeholder: "Buscar documento para adjuntar",
      title: "Elegir el tipo de documento",
      info: {
        documents: "documentos",
        date: "de",
        type: "Tipo de documento",
        noDocuments: "No se ha encontrado ningún documento",
      },
    },
    costs: {
      title: "Costes totales",
      title2: "desde el inicio del año",
    },
  },
  signature: {
    emptyDocs: "No tienes ningún documento para firmar",
    noService: "Aún no has solicitado la activación de este servicio",
    subtitle1: "Si solicitas la activación de ",
    subtitle2: ", puedes permitir que tus clientes firmen documentos electrónicamente, ",
    subtitle3: "directamente desde TS Digital Box: todas las soluciones de firma para cada necesidad, seguro FEA obligatorio ",
    subtitle4: "y el almacenamiento reglamentario incluido.",
    title: "PARA FIRMAR",
    back: "Volver a los documentos para firmar",
  },
  reconciliation: {
    title: "Cobros y pagos",
    actions: {
      linkToMovement: "Asociar al movimiento",
      saveAndLinkToMovement: "Guardar y asociar al movimiento",
    },
    abbuonoDescription:
      "Estás registrando un reembolso {residueValue} por la parte del movimiento bancario que supera el importe total de los vencimientos seleccionados ({value} en lugar de {totalAmount}).",
    movements: {
      title: "Movimientos en",
      nodata: "No se ha encontrado ningún movimiento. Prueba a configurar los filtros de forma diferente",
      titles: {
        today: "Hoy",
        lastWeek: "Últimos 7 días",
        lastMonth: "Último mes",
      },
      dialogs: {
        linkedTo: {
          title: "Plazos asociados al movimiento",
          tip: "Plazos asociados al movimiento de {date} de {amount} para {description}",
        },
      },
    },
    deadlines: {
      title: "Plazos",
      deadlineDate: "De {movementType} por",
      scope: "Alcance *",
      create: "Crear vencimiento a partir del remanente",
      cost: "Gastos",
      residueCost: "El remanente corresponde a un gasto por:",
      addExistingDeadline: "Añadir plazo existente",
      filter: "Aplicar filtros",
    },
    accounting: {
      pageTitle: "CONTABILIZACIÓN DE MOVIMIENTOS",
    },
  },
  parties: {
    create: {
      title: "Nuevo contacto",
      loader: "Guardando el contacto en curso...",
      paymentSubtitle: "Definir si se dividen los plazos en porcentajes o en fracciones",
      feedbackMessageSuccess: "¡Hecho! Contacto añadido con éxito.",
      feedbackMessageError: "Lo siento. Hubo un error al guardar",
      feedbackDescriptionError: "Vuelve a intentarlo más tarde",
    },
    edit: {
      feedbackMessageSuccess: "¡Hecho! Contacto modificado correctamente.",
      feedbackMessageError: "Lo siento. Hubo un error al guardar los cambios",
      feedbackDescriptionError: "Vuelve a intentarlo más tarde",
    },
    delete: {
      feedbackMessageSuccess: "¡Hecho! Contacto eliminado con éxito.",
      feedbackMessageError: "Lo siento. Hubo un error al borrar el contacto",
      feedbackDescriptionError: "Vuelve a intentarlo más tarde",
    },
    noPartyFound: "No hay contactos que coincidan con esta búsqueda.",
    viewMoreButton: "Ver más clientes",
    hideButton: "Ocultar clientes",
    installmentsError: "El total de las cuotas añadidas debe ser igual al 100%..",
    createNew: {
      pageTitle: "Nuevo contacto",
      searchDescription: "buscar entre empresas privadas y administraciones públicas",
      registryTabTitle: "Registro",
      paymentPlansTabTitle: "Relaciones comerciales",
    },
    paymentMode: "Métodos de pago",
    paymentTime: "Vencimiento de pago",
    paymentTitle: "Pago",
    payment: {
      MPXA: "Compensación",
      MP01: "Contado",
      MP02: "Cheque",
      MP03: "Cheque de caja",
      MP04: "Efectivo en Tesorería",
      MP05: "Transferencia bancaria",
      MP06: "Pagaré",
      MP07: "Boletín bancario o postal",
      MP08: "Tarjeta de pago",
      MP09: "RID",
      MP12: "RIBA",
      MP13: "MAV",
      MP14: "Recibo de Tesorería",
      MP15: "Transferencia a cuentas contables especiales",
      MP16: "Domiciliación bancaria o postal",
      MP19: "SEPA",
      MP22: "Retenciones a cuenta",
      MP23: "PagoPA",
      MPXC: "Cargo en cuenta corriente",
    },
  },
  reports: {
    resultNotFound: "No hay resultados para la búsqueda realizada!",
    downloadCsv: "Scarica in CSV",
    printPdf: "Stampa in PDF",
    balance: {
      kinds: {
        balanceSheet: {
          title: "Balance de situación",
          creditTitle: "Pasivo",
          debitTitle: "Activo",
        },
        incomeStatement: {
          title: "Cuenta de pérdidas y ganancias",
          creditTitle: "Ingresos",
          debitTitle: "Gastos",
        },
      },
    },
    vat: {
      yearSelect: "Establecer el año de referencia para mostrar la liquidación del IVA",
      yearRef: "Año de referencia*",
      yearSelectPlaceholder: "Selecciona el año",
      vatOnCredit: "IVA Soportado",
      vatOnDebit: "IVA Repercutido",
      reopenPeriod: "Período de reapertura",
      multiActivity: {
        previousVatCredit: "Cuotas a compensar pendientes de períodos anteriores",
        previousVatDebit: "Debito IVA periodo precedente",
        amountOnDebit: "Importe repercutido",
        amountOnCredit: "Importe soportado",
        activity: "Actividad",
      },
      VAT_ADVANCE_MONTHLY: "Acconto Iva",
      ADVANCE_MONTHLY: "Acconto Iva",
      ANNUAL: "Annuale",
      FIRST_QUARTER: "Primo Trimestre",
      SECOND_QUARTER: "Secondo Trimestre",
      THIRD_QUARTER: "Terzo Trimestre",
      VAT_ADVANCE_TRIMONTHLY: "Acconto Iva",
      ADVANCE_QUARTERLY: "Acconto Iva",
      FOURTH_QUARTER: "Quarto Trimestre",
      activityDetail: {
        summary: "Resumen",
        detail: "Detalle",
        description: "Descripción",
        rateExemption: "Tipo/Exención",
        rateDescription: "Descripción del tipo",
        taxable: "Imponible",
        tax: "Impuesto",
        nonDeductibleAmount: "Indetraibilità",
        total: "Total",
        activitySummary: "Resumen de actividad",
        previousDebt: "Deuda anterior",
        vatDeposit: "Anticipo IVA devengado",
        vatOn: "IVA en",
        reportedDebt: "Deuda a reportar",
      },
      aliquoteDetail: {
        reason: "Razón",
        registrationDate: "Fecha de registro",
        docNumber: "Número de documento",
        docDate: "Fecha de documento",
        destination: "Destino",
        nonDeductibility: "No deducible",
        vatCollectability: "Cobro del IVA",
        SPLIT_PAYMENT: "Split payment",
        DEFERRED: "IVA differita",
        IMMEDIATE: "Immediata",
      },
      vatAmountCredit: "Acquisti",
      vatAmountDebit: "Vendite",
      PURCHASE: "Acquisti",
      SALE: "Vendite",
      RECEIPT: "Corrispettivi",
      PURCHASE_NON_DETRAIBILE: "Indetraibilità",
      MARGINE_ORDINARIO_IMPREZIOSIMENTO: "Margine Ordinario Impreziosimento",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0730: "IVA Detraibile Agricoltura Speciale 0730",
      ESONERO_SALE_AGRICOLO: "Esonero Sale Agricolo",
      SALE_VAT_DST000: "-",
      ORDINARIO_PREVIOUS_CREDIT: "Credito IVA precedente",
      ORDINARIO_PREVIOUS_DEBIT: "Debito precedente (art.27 c.2)",
      MARGINE_ORDINARIO: "Imposta a debito regime del margine",
      SPLIT_PAYMENT_SALE: "vendite split payment a carico committente",
      CREDITO_DI_COSTO_PREV: "Credito di costo precedente",
      CREDITO_DI_COSTO_NEXT: "Credito di costo da riportare",
      IVA_MARGINE_GLOBALE: "Imposta a debito regime del margine",
      IVA_SU_CORRISP_MFR000: "IVA su Corrispettivi forfetari",
      IVA_SU_CORRISP_MFR001: "IVA su Corrispettivi forfetari",
      IVA_SU_CORRISP_MFR002: "IVA su Corrispettivi forfetari",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0200: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0400: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0600: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0640: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0730: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0750: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0765: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0795: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0830: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0850: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0880: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0950: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_1000: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_123: "IVA detraibile agricoltura speciale",
      SALE_SUBFORNITURA: "Iva agevolata art. 74 c.5",
    },
    vatEntries: {
      title: "Imposta i filtri per visualizzare il registro IVA",
      yearRef: "Anno di riferimento",
      yearSelectPlaceholder: "Selezion l'anno",
      periodRef: "Seleziona periodo",
      periodRefPlaceholder: "Scegli periodo",
      ANNUAL: "Tutti",
      JANUARY: "Gennaio",
      FEBRUARY: "Febbraio",
      MARCH: "Marzo",
      APRIL: "Aprile",
      MAY: "Maggio",
      JUNE: "Giugno",
      JULY: "Luglio",
      AUGUST: "Agosto",
      SEPTEMBER: "Settembre",
      OCTOBER: "Ottobre",
      NOVEMBER: "Novembre",
      DECEMBER: "Dicembre",
      businessRef: "Seleziona attività *",
      businessRefPlaceholder: "Scegli attività",
      typeRef: "Seleziona tipologia report IVA",
      typeRefPlaceholder: "Scegli tipologia",
      typeStarter: "Report IVA",
      clearFilters: "Pulisci i filtri",
      businessSummary: "Riepilogo attività",
      sectionalRef: "Scegli il sezionale *",
      sectionalRefPlaceholder: "Seleziona sezionale",
      table: {
        registrationDate: "Data registrazione",
        docType: "Tipo documento",
        vatType: "Tipologia IVA",
        docNumber: "Numero documento",
        docDate: "Data documento",
        customerOrSupplier: "Cliente/Fornitore",
        vatNumberOrTaxId: "P.IVA/C.F",
        aliquote: "Aliquota",
        taxable: "Imponibile",
        tax: "Imposta",
        taxEnums: {
          IVA4: "4%",
          IVA5: "5%",
          IVA22: "22%",
          IVA2: "2%",
          IVA0: "0%",
          ESC000: "0%",
          IVA10: "10%",
        },
        total: "Totale",
      },
    },
  },
  taxCredit: {
    title: "Créditos fiscales",
  },
  preCog: {
    sections: {
      cespiti: {
        tooltip: "Ir a la gestión de activos",
      },
      ritenute: {
        tooltip: "Ir a la gestión de las retenciones",
      },
      usedGoods: {
        tooltip: "Vai a gestione beni usati",
      },
    },
    draftStatusMessage: {
      DRAFT_ALREADY_ACCOUNTED: "La scrittura è già stata inviata in contabilità",
      REQUIRED_DOCUMENT_DATE: "Il campo Data documento non può essere vuoto",
      FAR_AHEAD_DOCUMENT_DATE: "La Data del documento deve essere precedente o uguale alla Data di registrazione",
      ACCOUNTING_LINES_SIZE: "La scrittura contabile deve avere almeno due conti.",
      REQUIRED_ACCOUNT_CODE: "Inserire conto contabile",
      BOTH_DEBIT_CREDIT: "Ogni contabile può essere movimentato o in dare o in avere.",
      FAR_AHEAD_START_PERIOD: "La data di Fine competenza non può essere antecedente a quella di Inizio competenza",
      REQUIRED_REGIME: "Ad ogni movimento deve essere associato un Regime",
      REQUIRED_EXEMPTION_NATURE: "Se % iva è pari a 0, scegliere la natura di esenzione",
      REQUIRED_ARTICLE_DESCRIPTION: "Non è possibile definire una % aliquota in questa registrazione",
      NOT_COMPATIBLE_REASON: "La causale contabile non è compatibile con il tipo di documento",
      REQUIRED_CURRENCY: "Il campo Valuta non può essere vuoto",
      REQUIRED_BUSINESS: "Il campo Attività non può essere vuoto",
      UNBALANCED_ENTRY: "Il totale Dare deve essere uguale al totale Avere",
      REQUIRED_ASSET_GROUP_KIND: "Il campo Gruppo e/o il campo Specie non possono essere vuoti ",
      REQUIRED_ASSET_SUBKIND: "Il campo Sottospecie non può essere vuoto",
      REQUIRED_ASSET_AVAILABILITY_DATE: "Il campo Data di disponibilità in anagrafica cespiti non può essere vuoto",
      REQUIRED_ASSET_TAX_DEPRECIATION: "Il campo Ammortamento fiscale non può essere vuoto",
      REQUIRED_ASSET_IRAP: "Il campo % IRAP deve essere compilato",
      UNNECESSARY_ASSET_IRAP: "Il campo % IRAP non deve essere compilato",
      REQUIRED_ASSET_STATUTORY_DEPRECIATION: "Il campo % di Ammortamento non può essere vuoto",
    },
    accountantContent: {
      registration: "Registrazione",
      receiptDate: "Ricezione",
      accountingReason: "Causale contabile",
      dataDoc: "Data documento",
      docNumber: "Numero documento",
      amount: "Importo",
      company: "Cliente/Fornitore",
      errorMessage: "Il dettaglio di questa registrazione non è disponibile.",
    },
    saveAndClose: "Guardar y cerrar",
    close: "Chiudi",
    create: "Crear un nuevo",
    createAccountingRecord: "Nuevo registro",
    confirmModal1: "Al continuar perderás todos los cambios que hayas hecho hasta ahora.",
    confirmModal2: "¿Estás seguro que quieres continuar?",
    deadline: "Plazo de",
    deadlineImport: "importe total: ",
    paymentMode: "Formas de pago: ",
    feedbackMessageSuccess: "Movimiento correctamente contabilizado.",
    feedbackMessageError: "Lo siento. Hubo un error al guardar.",
    message: {
      send: "Enviar",
      placeholder: "Deja un comentario",
      error: "Se ha producido un error",
    },
    label: {
      registrationDate: "Fecha de registro",
      customer: "Cliente",
      supplier: "Proveedor",
      reason: "Motivo",
      sectionalActivity: "Secciones - Actividades",
      accountingIdentifier: "Número de documento",
      movimentDate: "Fecha del documento",
      docDescription: "Descripción del documento",
    },
    modalNew: {
      title: "Nuevo registro",
      description1: "El motivo determina los detalles que tendrás que añadir.",
      description2: "¡Elige con cuidado!",
      selectReason: "Selecciona el motivo",
    },
    filters: {
      purchase: "Compra",
      sale: "Venta",
      bank_Transaction: "Movimientos bancarios",
      compensation: "Tasas",
      documents: "Documentos",
      toPaid: "A pagar",
      paid: "Pagado",
      partially_paid: "Parcialmente pagado",
    },
    typeFilters: {
      STATUTORY: "Civilistico",
      TAX: "Fiscale",
      IRAP: "IRAP",
      TAX_RELIEF: "Agevolazioni fiscali",
    },
    header: {
      document: "Documento",
      receipt: "Recibido el ",
      vat: "NIF / IVA",
      customer: "Cliente ",
      privateSale: "Venta privada",
      supplier: "Proveedor ",
      sdiId: "SDI Id",
      reason: "Motivo",
      activity: "Actividad",
      sectional: "Sección",
      vatCompetence: "Competencia IVA",
      vatCollectability: "Recaudación de IVA",
      SPLIT_PAYMENT: "Split payment",
      DEFERRED: "IVA differita",
      IMMEDIATE: "Esigibilità immediata",
      ordinary: "Ejecución inmediata",
      registrationDate: "Fecha de registro",
      docTotal: "Total del documento",
      movementTotal: "Total del movimiento",
      documentTotal: "Total del documiento",
      taxable: "Imponible",
      tax: "Impuesto",
      vatRegime: "Régimen de IVA",
    },
    accountingLines: {
      table: {
        accountingAccount: "Cuenta contable",
        previousBalance: "Balance anterior",
        vat: "IVA",
        regime: "Régimen",
        rate: "Tipo",
        destination: "Destino",
        give: "Dar",
        have: "Tener",
        amount: "Importo",
        taxable: "Imponibile",
        tax: "Imposta",
        startEndDate: "Principio y fin de la competencia",
      },
    },
    accountingTab: {
      accounting: "Contabilidad",
      regime: "Régimen",
      rate: "Tipo",
      destination: "Destino",
      receipt: "Recibo",
      receiptType: "Contraprestación",
      sdi: "SDI",
      amountDescription: "Importe",
      client: "Cliente",
      supplier: "Proveedor",
      collectability: "Recaudación de IVA",
      reverseCharge: "Cobro inverso",
      sectional: "Sección",
      reason: "Motivo contable",
      accountingAccount: "Cuenta contable",
      debit: "Debe",
      credit: "Haber",
      fixedAsset: "Activo",
      deferredInvoice: "Factura diferida",
      additions: "Integraciones",
      tooltipTitle: "Factura de venta con retenciones",
      documents: "Documentos",
      registration: "Registro contable",
      accountingSelected: "Cuentas seleccionadas",
      showOtherAccounts: "Ver otras cuentas",
      hideAccounts: "Ocultar",
      beneficiary: "Beneficiario",
      orderer: "Ordenante",
      change: "Editar",
      delete: "Elimina",
      invoicesRef: "Ref. Factura",
      movementDate: "Fecha de operación",
      noResults_filtered: "La búsqueda no produjo ningún resultado",
      noResults_accounted: "Non sono presenti movimenti contabilizzati",
      noResults_tryAgain: "Intenta configurar diferentes filtros o cancelar todos los filtros",
      moveTo: "Mover a",
      regimeSelect: "Selecciona el régimen",
      aliquoteSelect: "Selecciona la tasa",
      exemptionNature: "Naturaleza de la exención",
      destinationSelect: "Selecciona el destino",
    },
    drawerDetail: {
      ledger: "Libro Mayor",
      articles: "Artículos",
      accountRegistry: "Registro de cuentas",
      contoSelect: "Seleccionar cuentas",
      accountLedger: "Libro mayor de la cuenta",
      initialBalance: "Balance inicial",
      registrationDate: "Fecha de registro",
      selectAll: "Selecciona todo",
      noArticles: "No hay artículos en esta cuenta contable.",
      showAll: "Ver todo",
      accountDescription: "Descripción cuenta",
      noDeductibility: "No deducible",
      irpefOrIres: "IRPF/IS",
      fiscalIrap: "IRAP método de impuestos",
      civilisticIrap: "IRAP: método legal",
      nonDeductibilityPercentage: "% no deducible",
      vatDestination: "Destinazione IVA",
      accountType: {
        label: "Tipo conto",
        BALANCE_SHEET: "Patrimoniale",
        INCOME_STATEMENT: "Economico",
      },
      subjectToWitholdingTax: "Sujeto a retención de impuestos",
      fixedAssetsAccount: "Cuenta de activos fijos",
      subjectToSuspension: "Sujeto a suspensión",
    },
    usedGoods: {
      title: "Bene usato",
      sell: "Vendita",
      buy: "Acquisto",
      usedGoodsRegistry: "Anagrafica bene usato",
      accessoryExpense: "Spesa accessoria",
      selectUsedGoods: "Seleziona bene esistente",
      identificationData: "Dati identificativi",
      articles: "Articoli",
      quantity: "Quantità",
      buyDate: "Data di acquisto",
      idCode: "Cod. identificativo",
      description: "Descrizione",
      searchExistingGoods: "Cerca bene esistente",
      supplier: "Fornitore",
      description: "Descrizione",
      buyDate: "Data acquisto",
      total: "Importo",
      fixed: {
        description: "Descrizione",
        selection: "Seleziona",
        idCode: "Cod. identificativo",
        buyDate: "Data acquisto",
        sellDate: "Data vendita",
        search: "Cerca",
        totalPurchase: "Totale acquisto",
        marginAmount: "Margine lordo",
        accessories: "Spese accessorie",
        status: "Stato",
        table: {
          empty: {
            title: "Nessun bene usato",
          },
          NOT_SOLD: "Non venduto",
          SOLD: "Venduto",
        },
      },
    },
    assetsTab: {
      assets: "Activos",
      usedGoods: "Beni usati",
      fiscal_payments: "Ingresos y pagos",
      register: "Registrar para",
      assetsTotal: "Total de activos",
      assetsData: "Datos de activos",
      confirm: "Confirmar",
      newAsset: "Nuevo activo",
      existingAsset: "Activo existente",
      accountingLine: "Cuenta contable",
      separatedDeprecation: "Movimiento de amortización no deducible",
      save: "Guardar",
      back: "Volver",
      drawer: {
        disabled: "Per poter operare sui cespiti è necessario selezionare un'attività.",
        accountAssetsDetail: {
          drawerTitle: "Dati cespite",
          names: {
            fundAccount: "Conto fondi",
            depreciationRateAccount: "Conto quote ammortamento",
            capitalLossAccount: "Conto minusvalenze",
            capitalGainAccount: "Conto plusvalenze",
            toBeDividedCapitalGainAccount: "Conto plusvalenze da ripartire",
            revaluationAccount: "Conto rivalutazione",
            anticipatedDepreciationRateAccount: "Conto quote ammortamento anticipate",
            nonDeductibleDepreciationRateAccount: "Conto quote ammortamento indeducibile",
            disposalAccount: "Conto eliminazione processo produttivo",
            anticipatedDepreciationFundAccount: "Conto fondo ammortamento anticipato",
            nonTaxableCapitalGainAccount: "Conto plusvalenza non tassabile",
            nonDeductibleCostsAccount: "Conto costi indeducibili",
            nonDeductibleCostAccount: "Conto costi indeducibili",
            nonDeductibleDisposalAccount: "Conto eliminazione non deducibile",
            goodType: "Tipo bene deduz. extracontabili (Quadro EC Rediti)",
            parametersGoodType: "Tipo bene PARAMETRI",
            professionalCapitalLossAccount: "Conto minusvalenze professionisti",
            professionleCapitalGainAccount: "Conto plusvalenze professionisti",
            otherTaxDebts: "Altri debiti tributari",
          },
          type: {
            PURCHASE: "Acquisto",
            INCREASE: "Incremento",
            SUSPENDED: "Sospensione",
            ACTIVE: "Attivazione",
            DEPRECIATION: "Ammortamento",
            SALE: "Vendita",
            REVALUATE: "Rivalutazione",
            PARTIALLY_SALE: "Vendita Parziale",
            DISMISS: "Dismissione",
            PARTIALLY_DISMISS: "Dismissione Parziale ",
          },
        },
        fixedAsset: "Movimientos de activos fijos",
        registry: "Registro",
        depreciation: "Amortización",
        movementsTitle: "Movimientos",
        existingAssetValue: "Valor del activo existente",
        residualAt: "Remanente",
        activationDate2: "Fecha de activación",
        availabilityAndDeducibility: "Disponibilità e deducibilità",
        identificationData: "Datos de identificación",
        searchExistingAsset: "Buscar activos existentes *",
        existingAsset: "Activo existente",
        newOperation: "Nueva operación",
        incrementExistingAsset: "Incremento de activos existentes",
        alias: "Código de identificación",
        filterResults: "Filtrar resultados",
        cancelFilters: "Cancelar filtros",
        results: "Resultados",
        date: "Fecha",
        supplier: "Proveedores",
        lookForSupplier: "Buscar proveedor",
        amount: "Valor",
        group: "Grupo:",
        kind: "Tipo:",
        subKind: "Subtipo: ",
        materialGood: "Bien material",
        isNonMaterialGood: "Bien inmaterial",
        new: "Nuevo",
        used: "Usado",
        assetFullDescription: "Descripción adicional",
        activationDate: "Activación",
        suspensionDate: "Desactivación",
        availabilityDate: "Disponibilidad",
        isReducedDeductibility: "Deducibilidad reducida",
        deductability_50: "Deducibilidad del 50%",
        business_motorvehicles: "Vehículos de empresa",
        business_motorcycles: "Motos de empresa",
        business_mopeds: "Ciclomotores de empresa",
        representatives_motorvehicles: "Vehiculos de representantes",
        representatives_motorcycles: "Motos de representantes",
        representatives_mopeds: "Ciclomotores de representates",
        non_deductible_100: "100% No deducible",
        building_land: "Edificio con terreno",
        fixed_telephony: "Telefonía fija 80%",
        mobile_telephony: "Telefonía movil 80%",
        reducedDeductibilityExtraField: "Valor del terreno",
        mixedUseSelect: "Uso mixto",
        assignmentDateToEmployee: "Fecha de asignación",
        revocationDateToEmployee: "Fecha de revocación",
        depreciationRate: "Porcentaje de amortización",
        taxAmortization: "Amortización fiscal",
        statutoryDepreciationType: "Amortización legal",
        irapAmortization: "Amortización IRAP",
        otherDepreciationCriteria: "Otros criterios de amortización",
        taxRelief: "Desgravaciones",
        anticipate: "Anticipado {porcentaje}",
        irapPercent: "% IRAP",
        min: "Mínima {porcentaje}",
        MANUAL: "Manual {porcentaje}",
        DYNAMIC: "Dinámica {porcentaje}",
        LAW: "Ley {porcentaje}",
        sellingDepreciation: "Amortización de venta",
        otherFiscalData: "Otros datos fiscales",
        TAX_CRITERIA: "Según criterios fiscales",
        PERIOD: "Período de uso",
        DATA_END_PERIOD: "Fecha de finalización del período",
        FIXED_PERCENTAGE: "Porcentaje fijo",
        DESC_METHOD: "Método decreciente / Americano",
        otherFiscalAspects: "Otros aspectos fiscales",
        civilDepreciationValue_period: "Fecha de finalización del período",
        civilDepreciationValue_fixed_percentage: "Porcentaje fijo",

        civilDepreciationValue_desc_method: "Número de años en los que se amortiza el activo",
        statutoryDepreciationValue_FIXED_PERCENTAGE: "Amortización legal Valor porcentual fijo",
        statutoryDepreciationValue_DESC_METHOD: "Amortización legal Valor del método de descuento",
        statutoryDepreciationValue_PERIOD: "Período de valor de amortización legal",
        halfFirstYear: "50% primer año",
        reportInDays: "Ragguaglia in giorni",
        distributeCapitalGains: "Da ripartire",
        relief: "Desgravación",
        taxRelief: "Desgravación fiscal",
        taxReliefType: "Tipo de desgravación",
        taxReliefDate: "Fecha de desgravación",
        _2016_BALANCE_LAW: "Ley de Presupuestos 2016",
        _2017_BALANCE_LAW: "Ley de Presupuestos2017",
        _2018_BALANCE_LAW: "Ley de Presupuestos 2018",
        _2019_BALANCE_LAW: "Ley de Presupuestos 2019",
        _2019_GROWTH_DECREE: "Ley de Crecimiento 2019",
        _2020_BALANCE_LAW: "Ley de Presupuestos 2020",
        BASE: "Base",
        BASE4: "Base 4.0",
        SW4: "Software 4.0",
        selectedExisting: {
          type: "Tipo",
          operationDate: "Fecha de la operación",
          sellingPercentage: "Porcentaje de venta",
          sellingValue: "Valor de venta",
          ammortizationDuringYear: "Amortización durante el año",
          civilisticCapitalGain: "Plusvalía capital civil",
          civilisticCapitalLoss: "Pérdida de capital civil",
          fiscalCapitalGain: "Plusvalía de capital fiscal",
          fiscalCapitalLoss: "Pérdida de capital fiscal",
          description: "Descripción",
          showMovements: "Ver todos los movimientos",
          purchase: "Gastos adicionales",
          sale: "Venta",
          SALE: "Venta",
          value: "Valor",
        },
        buttons: {
          delete: "Eliminar",
          revaluation: "Revalorización",
          addMovements: "Añadir movimiento",
          backButton: "Movimenti cespiti",
        },
        logs: {
          purchaseTitle: "Aquisto iniziale",
          increaseTitle: "Spesa incrementativa",
          purchaseDocInfoTitle: "Dati del documento",
          docOpsInfoTitle: "Dati dell'operazione",
          docDate: "Data documento",
          docNumber: "Numero documento",
          docTaxRegion: "Ragione sociale fornitore",
          purchaseDate: "Data aquisto",
          invoiceAmount: "Valore del cespite",
          nonDeductibleVat: "Iva indetraibile",
          ancillaryCharges: "Oneri accessori",
          totalToBeDepreciated: "Totale da ammortizzare",
          depreciationTitle: "Ammortamento",
          depreciationDate: "Data ammortamento",
          depreciationPercentage: "% ammortamento",
          depreciationQuote: "Quota ammortamento",
          residualDepreciation: "Residuo ammortizzabile",
          accumulatedDepreciation: "Fondo ammortamento",
          suspensionPercentage: "% di sospensione",
          disposalDocInfoTitle: "Dismissione",
          disposalDate: "Data eliminazione",
          disposalPercentage: "% di eliminazione",
          saleDepreciation: "Amortamento in vendita",
          nonDeductibilityPercentage: "Amortamento idenducibile",
          revaluationDocInfoTitle: "Rivalutazione",
          revaluationDate: "Data rivalutazione",
          revaluationType: "Tipo rivalutazione",
          revalutationScope: "Ambito di applicazione",
          currentValue: "Valore corrente del bene",
          revaluationAmount: "Importo della rivalutazione",
          saleTitle: "Vendita",
          saleDate: "Data vendita",
          saleLogAmount: "Prezzo vendita",
          saleRate: "% vendita",
          saleCapitalGainStatutory: "Plusvalenza civilistica",
          saleCapitalLossStatutory: "Minusvalenza civisiltica",
          saleCapitalGainTax: "Plusvalenza fiscale",
          saleCapitalLossTax: "Minusvalenza fiscale",
          saleCarryingValue: "Residuo da ammortizzare",
        },
        movements: {
          loading: "Cargando datos. Por favor, espera.",
          amount: "Importe",
          residue: "Remanente",
          confirmRevaluation: "Confirma revalorización",
          backToMovements: "Volver a los movimientos",
          revaluation: "Revalorización",
          currentAssetValue: "Valor actual de los activos",
          effectiveDate: "Fecha efectiva de revaloración ",
          movementType: "Tipo de movimiento ",
          applicationType: "Ámbito de aplicación ",
          TAX: "Fiscale",
          STATUTORY: "Civilistico",
          STATUTORY_AND_TAX: "Civilistico e fiscale",
          REV_COST: "Rivalutazione del costo storico",
          REV_COST_AND_FUND: "Rivalutazione del costo storico e del fondo",
          DECR_FUND: "Decremento del fondo",
          revaluationSuccess: "Revalorización realizada con éxito",
          revaluationError: "Se ha producido un error! Revalorización no realizada con éxito",
          simulationRevaluationError: "Si è verificato un errore! Simulazione della rivalutazione fallita: ",
          next: "Siguiente",
          removeConfirm: "Confirmar la eliminación",
          backToMovements: "Volver a los movimientos",
          delete: "Eliminar",
          eliminationData: "Datos de eliminación",
          revaluationData: "Dati rivalutazione",
          previewAccount: "Vista previa de la cuenta",
          taxLoss: "Pérdida fiscal",
          civilLoss: "Pérdida de capital civil",
          deletePercentage: "Porcentaje de eliminación",
          note: "Notas",
          placeholderOperationDescription:
            "Por favor, introduce aquí cualquier dato adicional como: motivo de la eliminación, número y fecha del informe de destrucción o denuncia de robo, pérdida, etc.",
          assetDelete: "Eliminar activo",
          accountDescDebit: "Provisión para depreciación de equipos industriales y comerciales",
          accountDescCredit: "Baja de activo",
          sectional: "Sección",
          causalAccounting: "Causa contable",
          accountingAccount: "Cuenta contable",
          give: "Debe",
          have: "Haber",
        },
        deductibilityGoods: {
          NONE: "Indeducibilità al 100%",
          HALF: "Indeducibilità al 50%",
          BUSINESS_VEHICLES: "Autoveicoli aziendali",
          BUSINESS_MOTORCYCLES: "Motocicli aziendali",
          BUSINESS_MOPEDS: "Ciclomotori aziendali",
          REPRESENTATIVES_VEHICLES: "Motocicli rappresentanti",
          REPRESENTATIVES_MOTORCYCLES: "Autoveicoli rappresentanti",
          REPRESENTATIVES_MOPEDS: "Ciclomotori rappresentanti",
          BUILDING_AND_LAND: "Fabbricato con terreno",
          FIXED_TELEPHONY: "Telefonia fissa 80%",
          MOBILE_TELEPHONY: "Telefonia mobile 80%",
        },
      },
      tooltips: {
        identificationCode: "Introduce la matrícula, el número de protocolo, el código de inventario o el alias.",
        activationDate:
          "Ajuste en días sólo para el primer o el último año de actividad, si la fecha de inicio o de finalización de la actividad es diferente del 01/01",
        deactivationDate: "En caso de venta, sólo cuentan los días reales de posesión.",
        sellingDepreciation: "En caso de venta, sólo cuentan los días reales de posesión.",
        reportDays:
          "Riproporziona l'ammortamento in giorni solo per i movimenti che si riferiscono all' esercizio contabile dell'anno di costituzione e di cessazione dell'azienda.",
      },
    },
    intrastatTab: {
      intrastat: "Intrastat",
      addRow: "Añadir nomenclatura",
      registrationDate: "Fecha de registro en Intrastat  *",
      reason: "Registro para *",
      total: "Total a declarar",
      difference: "Diferencia",
      description: "Descripción nomenclatura",
      triangulation: "Triangulación",
      originProvince: "Provincia de origen*",
      originCountry: "País de origen",
      transactionCodeA: "Natura transazione A *",
      transactionCodeB: "Natura transazione B *",
      unitWeight: "Masa neta*",
      additionalUnit: "Unidad de medida adicional*",
      euroStatisticalAmount: "Valor estático en euros*",
      deliveryTerms: "Condiciones de entrega*",
      deliveryMode: "Modo de transporte*",
      destinationCountry: "País de destino*",
      shipmentOriginCountry: "País de origen",
      provinceDestination: "Provincia de destino",
      deliveryMethod: "Modalità di erogazione",
      collectionMode: "Modalità d'incasso",
      paymentCountry: "Paese di pagamento",
      customCode: "Sezione doganale",
      referenceFrequency: "Periodicità del modello da rettificare",
      referencePeriod: "Periodo di riferimento",
      correctionYear: "Anno",
      originalIntrastatRecord: "Protocollo di dichiarazione",
      statementNumber: "Progressivo sezione 3",
      state: "Stato",
      monthly: "Mensile",
      annual: "Anual",
      tooltips: {
        combinedNomenclature:
          "É possibile compilare gli elenchi riepilogativi senza disaggregazione della Nomenclatura combinata, utilizzando il codice unico 99500000, per le spedizioni di valore inferiore a euro 1.000. Per «spedizione» si intendono tutte le transazioni che durante il mese di riferimento sono oggetto della stessa fattura.",
        amount: "Le imposte sulla produzione e sui consumi pagate o da pagare in Italia non vanno comprese in detto ammontare.",
        unitWeight:
          "Indicare la massa netta, espressa in chilogrammi, delle merci prive di tutti i loro imballaggi. Per le sottovoci della nomenclatura combinata che prevedono anche l’unità supplementare, la colonna deve essere compilata esclusivamente dai soggetti che hanno realizzato nell'anno precedente o, in caso d'inizio dell'attivita' di scambi intracomunitari, presumono di realizzare nell'anno in corso, un valore delle spedizioni o degli arrivi superiore ad euro 20.000.000",
        euroStatisticalAmount:
          "La colonna deve essere compilata: a) dai soggetti che hanno realizzato nell'anno precedente o, in caso d'inizio dell'attivita' di scambi intracomunitari, presumono di realizzare nell'anno in corso, un valore delle spedizioni o degli arrivi superiore ad euro 20.000.000 indicano i dati relativi al valore statistico, alle condizioni di consegna ed al modo di trasporto nella parte statistica degli elenchi relativi alle cessioni intracomunitarie e, rispettivamente, agli acquisti intracomunitari di cui all'art. 1, comma 1, lettera a), n. 1) e di cui all'art. 1, comma 1, lettera b), n. 1). b) dagli altri soggetti, soltanto nel caso in cui, conformemente alle disposizioni in materia di imposta sul valore aggiunto, non è stata compilata la colonna 4.",
        deliveryTerms:
          "* I soggetti che hanno realizzato nell'anno precedente o, in caso d'inizio dell'attivita' di scambi intracomunitari, presumono di realizzare nell'anno in corso, un valore delle spedizioni o degli arrivi superiore ad euro 20.000.000 indicano i dati relativi al valore statistico, alle condizioni di consegna ed al modo di trasporto nella parte statistica degli elenchi relativi alle cessioni intracomunitarie e, rispettivamente, agli acquisti intracomunitari di cui all'art. 1, comma 1, lettera a), n. 1) e di cui all'art. 1, comma 1, lettera b), n. 1).",
        deliveryMode:
          "* I soggetti che hanno realizzato nell'anno precedente o, in caso d'inizio dell'attivita' di scambi intracomunitari, presumono di realizzare nell'anno in corso, un valore delle spedizioni o degli arrivi superiore ad euro 20.000.000 indicano i dati relativi al valore statistico, alle condizioni di consegna ed al modo di trasporto nella parte statistica degli elenchi relativi alle cessioni intracomunitarie e, rispettivamente, agli acquisti intracomunitari di cui all'art. 1, comma 1, lettera a), n. 1) e di cui all'art. 1, comma 1, lettera b), n. 1).",
        shipmentOriginCountry:
          "*Qualora le merci, prima di entrare in Italia, abbiano fatto sosta in uno o più Stati membri per operazioni non inerenti al trasporto, indicare il codice dello Stato membro in cui si è verificata l’ultima sosta.",
        destinationCountry: "Indicare il codice ISO del Paese membro di destinazione delle merci",
        originCountry:
          "Le merci interamente ottenute o prodotte in un unico Stato membro o paese o territorio sono originarie di tale Stato membro o paese o territorio. Le merci la cui produzione riguarda più di uno Stato membro o paese o territorio sono considerate originarie dello Stato membro o paese o territorio in cui sono state sottoposte all’ultima trasformazione o lavorazione sostanziale, economicamente giustificata, effettuata in un’impresa attrezzata a tale scopo, che abbia determinato la fabbricazione di un prodotto nuovo o che rappresenta uno stadio importante del processo di fabbricazione. L’origine delle merci non unionali è determinata conformemente alle disposizioni del codice doganale dell’Unione che stabilisce le norme in materia di origine.",
        originProvince:
          "Se la provincia di origine/produzione non è nota oppure non è italiana, indicare la sigla automobilistica della provincia di spedizione delle merci",
        destinationProvince:
          "Indicare la sigla automobilistica della provincia in cui le merci sono destinate al consumo o alla commercializzazione ovvero assoggettate ad operazioni di perfezionamento.",
        deliveryMethod: "Indicazione facoltativa per elenchi riepilogativi con periodo di riferimento decorrenti dall’anno 2015",
        collectionMode: "Indicazione facoltativa per rettifiche ad elenchi riepilogativi con periodo di riferimento decorrenti dall’anno 2015",
        paymentCountry: "Indicare il Codice ISO del Paese in cui viene effettuato il pagamento del servizio reso.",
        customCode: "Indicare il codice dell’ufficio doganale al quale è stato presentato l’elenco da rettificare.",
      },
    },
    fiscalPayments: {
      titleRegister: "Registrar el pago contextual",
      titleInvoice1: "Facturas de venta ",
      titleInvoice2: " a cobrar",
      titleAssociate: "Pagos de anticipos de asociados para TeamSystem",
      subtitleTableAdvances: "Selecciona uno o más pagos ya registrados para asociarlos a este documento",
      subtitleTableInvoices: "Selecciona una o más facturas para asociarlas a este movimiento de caja recién registrado",
      searchLedgerAccount: "Buscar cuenta",
    },
    deadlinesTab: {
      deadlines: "Plazos",
    },
    withholdingsTab: {
      drawer: {
        masterTitle: "Sección de retención de impuestos",
        title: "Sección de Retención Fiscal",
        titleInps: "Sección INSS",
        fields: {
          amount: "Base imponible de la retención",
          taxableAmount: "Base imponible de la retención",
          totalNetAmount: "Total de la factura sin IVA",
          withholdingRate: "% Tasa de retención",
          reason: "Motivo de la prestación",
          cuReason: "Motivo del modelo de CU",
          cashContribution: "Contribución adicional",
          notIncomeAmount: "Sumas que no constituyen ingresos",
          exemptIncome: "Renta exenta",
          notWithholdingIncome: "Rentas no sujetas a retención",
          // taxableAmount: "Retención imponible",
          withHoldingDepositAmount: "Importe de la retención ",
          withHoldingTaxAmount: "Importe retenido",
          taxableContribution: "Retención a cuenta",
          tributeCode: "Código tributario",
          socialInstituteTaxableAmount: "Base imponible INSS",
          socialInstituteContributionRate: "Porcentaje de cotización al INSS",
          alreadySubjectedAmount: "Importe ya sujeto",
          recipientContribution: "Contribución del perceptor",
          companyContribution: "Contribución de la empresa",
          activityStartDate: "Período de actividad de",
          activityEndDate: "Periodo de actividad para",
          emensReportType: "EMENS - Tipo de informe",
          emensActivityCode: "EMENS - Código de actividad",
          emensOtherInsurance: "EMENS - Otros seguros",
          ensarcoContribution: "Contribución de ENSARCO",
          enpamContribution: "Contribución de ENPAM",
          othersContribution: "Otras cotizaciones a la seguridad social",
        },
      },
    },
    vatTab: {
      vat: "Resumen del IVA",
    },
    bottomBar: {
      error1: "El importe del documento no puede ser 0",
      error2: "Comprobar las cuentas del libro mayor",
      error3: "Comprobar las cuentas del IVA",
      error4: "Comprobar los detalles del documento",
      saveTime: "hace menos de un minuto",
      goBack: "Volver",
      confirm: "Cuentas",
    },
    widget: {
      evidence: {
        title: "In evidenza",
        registrationDate: "Data ultima registrazione contabile",
        documentsContains: "Documenti contenenti:",
        withHoldings: "Ritenute",
        intrastat: "Intrastat",
        assets: "Cespiti",
        nonRegisteredMessage: "Tutti i tuoi documenti sono stati registrati",
      },
      accountedFor: "A contabilizar",
      accountedForSubtitle: "Contabilizados desde principios de año ",
      counterDetail: {
        activeInvoice: "Facturas de venta",
        passiveInvoice: "Facturas de compra",
        compensation: "Tarifa",
        bankMovements: "Transacciones bancarias",
        others: "Altri",
      },
      vatSummary: {
        title: "Riepilogo IVA ",
        monthly: "mensile",
        quarterly: "trimestrale",
        MONTHLY: "mensile",
        QUARTERLY: "trimestrale",
        MIXED: "misto",
        mixed: "misto",
        quater: "trimestre",
        tooltip: {
          vatSummary: "última fecha de registro",
        },
        vat: "IVA",
      },
      documents: "Documentos",
      btnNew: "Añadir doc o xml",
    },
  },
  addressBook: {
    title: "Agenda",
    empty: "Aún no hay contactos",
    addFirst: "Añade tu primer contacto",
    customers: "Clientes",
    suppliers: "Proveedores",
    customer: "Cliente",
    supplier: "Proveedore",
    payments: "Pagos",
    create: {
      title: "Nuevo contacto",
      installment: "Plazo",
      giorni: "días",
      mesi: "meses",
      installmentAmount: "Importe del Plazo",
      firstChoice: "Fecha factura",
      secondChoice: "Fecha factura fin de mes",
      addInstallment: "Añadir plazo",
      removeInstallment: "Eliminar plazo",
      paymentMode: { label: "Forma de pago", placeholder: " " },
      paymentTerms: { label: "Condiciones de pago" },
      businessName: { label: "Razón social", placeholder: "Introduce la razón social" },
      country: { label: "País de referencia", placeholder: "País de referencia" },
      vat: { label: "NIF/IVA" },
      tax: { label: "NIF", placeholder: "Introduce NIF" },
      eori: { label: "Código EORI", placeholder: "Introduce código EORI" },
      name: { label: "Nombre", placeholder: "Introduce nombre" },
      surname: { label: "Apellidos", placeholder: "Introduce apellidos" },
      sdi: { label: "SDI", placeholder: "Introduce SDI" },
      addressCountry: { label: "País", placeholder: "País" },
      addressCity: { label: "Municipio", placeholder: "Introduce municipio" },
      addressZip: { label: "Cód. postal" },
      addressProvince: { label: "Provincia", placeholder: "Provincia" },
      addressSpaceType: { label: "Calle/Plaza", placeholder: "Introduce calle/plaza" },
      addressPec: { label: "Correo electrónico certificado", placeholder: "Introduce correo electrónico certificado" },
    },
  },
  main: {
    studioSelector: {
      title: "Elige el tipo de empresa",
      title2: "con la quieres trabajar",
    },
    sidebar: {
      home: "Inicio",
      documents: "Documentos",
      deadlines: "Plazos",
      customerPage: "Ficha de cliente",
      folders: "Expedientes",
      ask: "Solicitudes",
      toSign: "Para firmar",
      digitalSignature: "Firma digital",
      fulfilments: "Obligaciones",
      precog: "Precontabilidad",
      accountingYears: "Ejercicios contables",
      accountingPlan: "Plan de cuentas",
      reports: "Informes",
      taxCredit: "Créditos fiscales",
      accounting: "TODO:Contabilità e fisco",
      collaboration: "TODO:Collaboration",
      customers: "TODO:Clienti",
      chartAccounts: "TODO:Prima Nota",
      documental: "TODO:Documentale",
      businessPerformance: "Rendimiento empresarial",
    },
    userBadge: {
      information: "Información",
      user: "Usuario",
      studio: "Asesoria",
      company: "Empresa",
      fiscalCode: "NIF",
      vatNumber: "NIF/IVA",
      logout: "Salir",
      downloadApp: "Descargar la App",
      goProfile: "Ir a tu perfil",
      goAccounts: "Mis asesorías",
    },
  },
  permissions: {
    "Nella sua home": "En su página de inicio",
    "Nel suo menu": "En su menú",
    "Nei suoi documenti": "En sus documentos",
    "Riepilogo costi": "Resumen de costes",
    "Business Performance": "Rendimiento empresarial",
    "Checkup Impresa": "Checkup Impresa",
    "Incassa Subito": "Incassa Subito",
    "Incassa subito": "Incassa Subito",
    "Volume d'affari": "Volumen de negocios",
    Richieste: "Solicitudes",
    Fascicoli: "Expedientes",
    Altri: "Otros",
    Fatture: "Facturas",
    Fiscale: "Fiscal",
    Azienda: "Empresa",
    "Gestione del personale": "Gestión de personal",
    "Via web": "Vía web",
    "Via app": "Vía app",
    "Via mail": "Vía mail",
    "Auto invio XML": "Envío automático XML",
    "Può firmare": "Firmar documentos",
    "Firmare documenti": "Firmar documentos",
    "Autorizzare pagamenti e scadenze": "Autorizar pagos y plazos",
    "Autorizza scadenze fiscali e previdenziali": "Autorizar plazos fiscales y de seguridad social",
    "Vede scadenze create da fatture": "Ver plazos creados por facturas",
    "Autorizza disposizioni di pagamento": "Autorizar órdenes de pago",
    "Fatturato clienti": "Facturación de clientes",
    "Margine sul fatturato": "Margen sobre facturación",
    "Fatturato consolidato, DDT emessi e ordini residui": "Facturación consolidada, albaranes emitidos y pedidos pendientes",
    "Venduto clienti": "Ventas a clientes",
    "Margine sull'ordinato": "Margen sobre pedidos",
    "Fatturato fornitori": "Facturación de proveedores",
    "Ripartizione beni e servizi": "Desglose de bienes y servicios",
    "Ordini emessi a fornitori ": "Pedidos a proveedores",
    "Residuo ordini fornitori": "Pedidos pendientes a proveedores",
    "Ordini fornitori scaduti": "Vencimientos pendientes de proveedores",
    "Fatturato consolidato passivo, DDT ricevuti e ordini da evadere": "Facturación recibida consolidada, albaranes recibidos y pedidos pendientes de tramitar",
    "Scadenze attive totali": "Vencimientos activos totales",
    "Scadenze clienti totali": "Vencimientos totales de los clientes",
    "Insoluti totali": "Total importes pendientes",
    "Insoluti Clienti": "Clientes impagados",
    "Cash flow": "Cash Flow",
    "Valore magazzino": "Valoración de existencias",
    "Indice di rotazione": "Índice de rotación",
    Scadenze: "Plazos",
  },
  customers: {
    title: "MIS CLIENTES",
    feedback: {
      ok: "Hecho. La solicitud ha sido aceptada. Si el cliente sigue inactivo, comprueba que haya aceptado la invitación.",
    },
  },
  validation: {
    status: {
      VALIDATED: "VALIDADO",
      CERTIFIED: "CERTIFICADO",
      UNVERIFIABLE: "NO VALIDADO",
      UNVERIFIABLE_PENDING_VALIDATE: "ESPERANDO VALIDACIÓN",
    },
    error: {
      title: "Ocurrió un error",
      message: "Generación de formulario de suscripción",
    },
    feedback: {
      title: "Solicitud enviada exitosamente!",
      message: "Su solicitud de validación ha sido enviada",
      btn: "Volver a la página de inicio",
    },
    confirm: "¿Confirmas que los datos son correctos?",
    actions: {
      select: "Seleccionar",
      cancel: "Cancelar",
      edit: "Editar",
      submit: "Enviar datos",
    },
    offices: {
      1: "Dueño de la compañía",
      2: "Representante legal",
      3: "Asesoría",
    },
    officesDoc: {
      1: "Propietario",
      2: "Representante legal",
      3: "Asesor",
    },
    data: {
      status: "Estado",
      type: "Tipología",
      taxId: "NIF",
      vatNumber: "NIF/IVA",
      name: "Nombre",
      surname: "Apellido",
      office: "Cargo",
      city: "Lugar",
      date: "Datos",
    },
    form: {
      1: {
        title: "1. Introduce tus datos y gestiona tus opciones de tratamiento de datos",
        subtitle: "Complete los datos requeridos para generar el formulario de suscripción digital TS previamente completado",
        formTitle:
          "Elija los consentimientos que desea otorgar al Servicio TeamSystem: un consentimiento positivo le permitirá mantenerse actualizado sobre nuestras promociones. Recuerda que puedes cambiar tu elección en cualquier momento",
        consentLink: "Haga clic aquí",
        consentTitle: "para leer la información sobre el tratamiento de sus datos personales.",
        consent1:
          "Autorizo ​​el procesamiento de mis datos personales, incluidos los relacionados con el uso del sitio y los productos y servicios de TeamSystem, para recibir por correo electrónico, correo postal, mensajes instantáneos, chat o teléfono actualizaciones sobre noticias y ofertas comerciales de productos y servicios de TeamSystem, o para las demás iniciativas de marketing indicadas en la información.",
        consent2: "Autorizo ​​la comunicación de mis datos personales a otras empresas del grupo TeamSystem y sus socios con fines comerciales y de marketing.",
        btn: "Continuar",
      },
      2: {
        title: "2. Generar el formulario de suscripción digital de TS",
        subtitle: "Generar el Formulario de Suscripción a TS Digital con los datos ingresados ​​previamente.",
        btn: "Descargar el contrato de suscripción",
      },
      3: {
        title: "3. Cargue el formulario de suscripción digital de TS",
        subtitle: "Cargue el archivo firmado para continuar con la validación.",
        btn: "Subir el contrato de suscripción",
      },
    },
  },
};
